import { Injectable } from '@angular/core';
import { environment } from '@env';
import { translate } from '@ngneat/transloco';

import { IntegrationModal } from '../../interface/integrationmodal.interface';

@Injectable({
    providedIn: 'root',
})
export class IntegrationsConfigService {
    constructor() {}

    environment = environment.restrictedFeatures;
    integrationRestriction = this.environment?.integrations || [];
    translator = (stringToTranslate: string): string => translate(`${stringToTranslate}`);

    globalConfigs: IntegrationModal[] = [
        {
            displayName: 'FTP',
            api: 'FTP',
            tableFieldIds: ['name', 'serverAddress', 'createdByName', 'createdOn', 'lastUpdatedByName', 'lastUpdatedOn'],
            canAddRecord: true,
            canTestConnection: true,
            canUpdateRecord: true,
            canDeleteRecord: true,
            canDownloadAuditTrail: true,
            tableRecordActions: [],
            fields: [
                {
                    id: 'name',
                    displayName: 'Name',
                    required: true,
                    type: 'TEXT',
                    validations: ['maxLength250', 'minLength3', 'mustContainAlphaAsFirstLetter'],
                    conditionalDisable: [
                        {
                            type: 'ANY_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'id',
                                    valueExists: true,
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'useMaster',
                    displayName: 'Use Master',
                    required: true,
                    isMasterField: true,
                    defaultValue: false,
                    type: 'INPUT_RADIO',
                    options: [
                        {
                            id: 'yes',
                            displayName: 'Yes',
                            value: true,
                        },
                        {
                            id: 'no',
                            displayName: 'No',
                            value: false,
                        },
                    ],
                    supportedDisableProperty: 'useMasterDisabled',
                },
                {
                    id: 'masterName',
                    displayName: 'Master Data Table',
                    required: true,
                    type: 'MASTER_DROPDOWN',
                    conditionalDisplay: [
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: true,
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'protocol',
                    displayName: 'Protocol',
                    required: true,
                    inputTypeConditonal: true,
                    type: [
                        {
                            fieldId: 'useMaster',
                            requiredValue: true,
                            type: 'DROPDOWN',
                        },
                        {
                            fieldId: 'useMaster',
                            requiredValue: false,
                            type: 'OPTIONS',
                        },
                    ],
                    options: [],
                    supportOptionsConfigProperty: 'ftpProtocols',
                    conditionalDisplay: [
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: false,
                                },
                            ],
                        },
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: true,
                                },
                                {
                                    fieldId: 'masterName',
                                    valueExists: true,
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'serverAddress',
                    displayName: 'Server Address',
                    required: true,
                    conditionalDisplay: [
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: false,
                                },
                                {
                                    fieldId: 'protocol',
                                    valueExists: true,
                                },
                            ],
                        },
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: true,
                                },
                                {
                                    fieldId: 'masterName',
                                    valueExists: true,
                                },
                            ],
                        },
                    ],
                    inputTypeConditonal: true,
                    type: [
                        {
                            fieldId: 'useMaster',
                            requiredValue: true,
                            type: 'DROPDOWN',
                        },
                        {
                            fieldId: 'useMaster',
                            requiredValue: false,
                            type: 'TEXT',
                        },
                    ],
                },
                {
                    id: 'port',
                    displayName: 'Port',
                    required: true,
                    inputTypeConditonal: true,
                    type: [
                        {
                            fieldId: 'useMaster',
                            requiredValue: true,
                            type: 'DROPDOWN',
                        },
                        {
                            fieldId: 'useMaster',
                            requiredValue: false,
                            type: 'TEXT',
                        },
                    ],
                    conditionalDisplay: [
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: false,
                                },
                                {
                                    fieldId: 'protocol',
                                    valueExists: true,
                                },
                            ],
                        },
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: true,
                                },
                                {
                                    fieldId: 'masterName',
                                    valueExists: true,
                                },
                            ],
                        },
                    ],
                    validations: ['checkNumberOnly'],
                },
                {
                    id: 'maxNoOfConnections',
                    displayName: 'Maximum No. of Connections',
                    required: false,
                    inputTypeConditonal: true,
                    type: [
                        {
                            fieldId: 'useMaster',
                            requiredValue: true,
                            type: 'DROPDOWN',
                        },
                        {
                            fieldId: 'useMaster',
                            requiredValue: false,
                            type: 'TEXT',
                        },
                    ],
                    conditionalDisplay: [
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: false,
                                },
                                {
                                    fieldId: 'protocol',
                                    valueExists: true,
                                },
                            ],
                        },
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: true,
                                },
                                {
                                    fieldId: 'masterName',
                                    valueExists: true,
                                },
                            ],
                        },
                    ],
                    validations: ['checkNumberOnly', 'checkMinimumNumberValue'],
                },
                {
                    id: 'folderPath',
                    displayName: 'Folder Path',
                    required: true,
                    inputTypeConditonal: true,
                    type: [
                        {
                            fieldId: 'useMaster',
                            requiredValue: true,
                            type: 'DROPDOWN',
                        },
                        {
                            fieldId: 'useMaster',
                            requiredValue: false,
                            type: 'TEXT',
                        },
                    ],
                    conditionalDisplay: [
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: false,
                                },
                                {
                                    fieldId: 'protocol',
                                    valueExists: true,
                                },
                            ],
                        },
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: true,
                                },
                                {
                                    fieldId: 'masterName',
                                    valueExists: true,
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'userName',
                    displayName: 'User Name',
                    required: true,
                    inputTypeConditonal: true,
                    type: [
                        {
                            fieldId: 'useMaster',
                            requiredValue: true,
                            type: 'DROPDOWN',
                        },
                        {
                            fieldId: 'useMaster',
                            requiredValue: false,
                            type: 'TEXT',
                        },
                    ],
                    conditionalDisplay: [
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: false,
                                },
                                {
                                    fieldId: 'protocol',
                                    valueExists: true,
                                },
                            ],
                        },
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: true,
                                },
                                {
                                    fieldId: 'masterName',
                                    valueExists: true,
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'addKey',
                    displayName: 'Add Key',
                    required: true,
                    defaultValue: false,
                    conditionalDisplay: [
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: false,
                                },
                                {
                                    fieldId: 'protocol',
                                    requiredValue: 'SFTP',
                                },
                            ],
                        },
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: true,
                                },
                                {
                                    fieldId: 'masterName',
                                    valueExists: true,
                                },
                            ],
                        },
                    ],
                    inputTypeConditonal: true,
                    type: [
                        {
                            fieldId: 'useMaster',
                            requiredValue: true,
                            type: 'DROPDOWN',
                        },
                        {
                            fieldId: 'useMaster',
                            requiredValue: false,
                            type: 'INPUT_RADIO',
                            options: [
                                {
                                    id: 'yes',
                                    displayName: 'Yes',
                                    value: true,
                                },
                                {
                                    id: 'no',
                                    displayName: 'No',
                                    value: false,
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'password',
                    displayName: 'Password',
                    required: true,
                    inputTypeConditonal: true,
                    type: [
                        {
                            fieldId: 'useMaster',
                            requiredValue: true,
                            type: 'DROPDOWN',
                        },
                        {
                            fieldId: 'useMaster',
                            requiredValue: false,
                            type: 'PASSWORD',
                        },
                    ],
                    conditionalDisplay: [
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: true,
                                },
                                {
                                    fieldId: 'masterName',
                                    valueExists: true,
                                },
                            ],
                        },
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: false,
                                },
                                {
                                    fieldId: 'protocol',
                                    requiredValue: 'SFTP',
                                },
                                {
                                    fieldId: 'addKey',
                                    requiredValue: false,
                                },
                            ],
                        },
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: false,
                                },
                                {
                                    fieldId: 'protocol',
                                    requiredValue: 'FTP',
                                },
                            ],
                        },
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: false,
                                },
                                {
                                    fieldId: 'protocol',
                                    requiredValue: 'FTPS',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'encryptedKey',
                    displayName: 'Encrypted Key',
                    required: true,
                    hint: '(Encrypted RSA key)',
                    inputTypeConditonal: true,
                    type: [
                        {
                            fieldId: 'useMaster',
                            requiredValue: true,
                            type: 'DROPDOWN',
                        },
                        {
                            fieldId: 'useMaster',
                            requiredValue: false,
                            type: 'TEXTAREA',
                        },
                    ],
                    conditionalDisplay: [
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: true,
                                },
                                {
                                    fieldId: 'masterName',
                                    valueExists: true,
                                },
                            ],
                        },
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: false,
                                },
                                {
                                    fieldId: 'protocol',
                                    valueExists: true,
                                },
                                {
                                    fieldId: 'addKey',
                                    requiredValue: true,
                                },
                            ],
                        },
                    ],
                    hasEncoding: true,
                    hasDecoding: true,
                    encodingType: 'btoa',
                    decodingType: 'atob',
                },
                {
                    id: 'createdByName',
                    displayName: 'Created By',
                    required: false,
                    type: 'TEXT',
                    show: false,
                    copyToPayload: false,
                },
                {
                    id: 'createdOn',
                    displayName: 'Created Date',
                    required: false,
                    type: 'TEXT',
                    show: false,
                    decodingType: 'DATE',
                    copyToPayload: false,
                },
                {
                    id: 'lastUpdatedByName',
                    displayName: 'Modified By',
                    required: false,
                    type: 'TEXT',
                    show: false,
                    copyToPayload: false,
                },
                {
                    id: 'lastUpdatedOn',
                    displayName: 'Modified Date',
                    required: false,
                    type: 'TEXT',
                    show: false,
                    decodingType: 'DATE',
                    copyToPayload: false,
                },
            ],
        },
        {
            displayName: 'S3',
            api: 'S3',
            tableFieldIds: ['name', 'accessKeyId', 'createdByName', 'createdOn', 'lastUpdatedByName', 'lastUpdatedOn'],
            canAddRecord: true,
            canTestConnection: true,
            canUpdateRecord: true,
            canDeleteRecord: true,
            canDownloadAuditTrail: true,
            tableRecordActions: [],
            fields: [
                {
                    id: 'name',
                    displayName: 'Name',
                    required: true,
                    type: 'TEXT',
                    validations: ['maxLength250', 'minLength3', 'mustContainAlphabets', 'mustContainAlphaAsFirstLetter'],
                    conditionalDisable: [
                        {
                            type: 'ANY_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'id',
                                    valueExists: true,
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'useMaster',
                    displayName: 'Use Master',
                    required: true,
                    isMasterField: true,
                    defaultValue: false,
                    type: 'INPUT_RADIO',
                    options: [
                        {
                            id: 'yes',
                            displayName: 'Yes',
                            value: true,
                        },
                        {
                            id: 'no',
                            displayName: 'No',
                            value: false,
                        },
                    ],
                    supportedDisableProperty: 'useMasterDisabled',
                },
                {
                    id: 'masterName',
                    displayName: 'Master Data Table',
                    required: true,
                    type: 'MASTER_DROPDOWN',
                    conditionalDisplay: [
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: true,
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'accessKeyId',
                    displayName: 'Access Key Id',
                    required: true,
                    conditionalDisplay: [
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: false,
                                },
                            ],
                        },
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: true,
                                },
                                {
                                    fieldId: 'masterName',
                                    valueExists: true,
                                },
                            ],
                        },
                    ],
                    inputTypeConditonal: true,
                    type: [
                        {
                            fieldId: 'useMaster',
                            requiredValue: true,
                            type: 'DROPDOWN',
                        },
                        {
                            fieldId: 'useMaster',
                            requiredValue: false,
                            type: 'TEXT',
                        },
                    ],
                },
                {
                    id: 'secretAccessKey',
                    displayName: 'Secret Access Key',
                    required: true,
                    inputTypeConditonal: true,
                    type: [
                        {
                            fieldId: 'useMaster',
                            requiredValue: true,
                            type: 'DROPDOWN',
                        },
                        {
                            fieldId: 'useMaster',
                            requiredValue: false,
                            type: 'TEXT',
                        },
                    ],
                    conditionalDisplay: [
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: false,
                                },
                            ],
                        },
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: true,
                                },
                                {
                                    fieldId: 'masterName',
                                    valueExists: true,
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'bucketName',
                    displayName: 'Bucket Name',
                    required: true,
                    inputTypeConditonal: true,
                    type: [
                        {
                            fieldId: 'useMaster',
                            requiredValue: true,
                            type: 'DROPDOWN',
                        },
                        {
                            fieldId: 'useMaster',
                            requiredValue: false,
                            type: 'TEXT',
                        },
                    ],
                    conditionalDisplay: [
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: false,
                                },
                            ],
                        },
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: true,
                                },
                                {
                                    fieldId: 'masterName',
                                    valueExists: true,
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'folderPath',
                    displayName: 'Folder Path',
                    required: true,
                    inputTypeConditonal: true,
                    type: [
                        {
                            fieldId: 'useMaster',
                            requiredValue: true,
                            type: 'DROPDOWN',
                        },
                        {
                            fieldId: 'useMaster',
                            requiredValue: false,
                            type: 'TEXT',
                        },
                    ],
                    conditionalDisplay: [
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: false,
                                },
                            ],
                        },
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: true,
                                },
                                {
                                    fieldId: 'masterName',
                                    valueExists: true,
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'region',
                    displayName: 'Region',
                    required: true,
                    inputTypeConditonal: true,
                    type: [
                        {
                            fieldId: 'useMaster',
                            requiredValue: true,
                            type: 'DROPDOWN',
                        },
                        {
                            fieldId: 'useMaster',
                            requiredValue: false,
                            type: 'OPTIONS',
                        },
                    ],
                    conditionalDisplay: [
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: true,
                                },
                                {
                                    fieldId: 'masterName',
                                    valueExists: true,
                                },
                            ],
                        },
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'useMaster',
                                    requiredValue: false,
                                },
                            ],
                        },
                    ],
                    options: [
                        {
                            id: 'us-east-1',
                            value: 'us-east-1',
                            displayName: 'US East (N. Virginia)',
                        },
                        {
                            id: 'us-east-2',
                            value: 'us-east-2',
                            displayName: 'US East (Ohio)',
                        },
                        {
                            id: 'us-west-1',
                            value: 'us-west-1',
                            displayName: 'US West (N. California)',
                        },
                        {
                            id: 'us-west-2',
                            value: 'us-west-2',
                            displayName: 'US West (Oregon)',
                        },
                        {
                            id: 'ca-central-1',
                            value: 'ca-central-1',
                            displayName: 'Canada (Central)',
                        },
                        {
                            id: 'eu-central-1',
                            value: 'eu-central-1',
                            displayName: 'EU (Frankfurt)',
                        },
                        {
                            id: 'eu-west-1',
                            value: 'eu-west-1',
                            displayName: 'EU (Ireland)',
                        },
                        {
                            id: 'eu-west-2',
                            value: 'eu-west-2',
                            displayName: 'EU (London)',
                        },
                        {
                            id: 'eu-west-3',
                            value: 'eu-west-3',
                            displayName: 'EU (Paris)',
                        },
                        {
                            id: 'ap-northeast-1',
                            value: 'ap-northeast-1',
                            displayName: 'Asia Pacific (Tokyo)',
                        },
                        {
                            id: 'ap-northeast-2',
                            value: 'ap-northeast-2',
                            displayName: 'Asia Pacific (Seoul)',
                        },
                        {
                            id: 'ap-northeast-3',
                            value: 'ap-northeast-3',
                            displayName: 'Asia Pacific (Osaka-Local)',
                        },
                        {
                            id: 'ap-southeast-1',
                            value: 'ap-southeast-1',
                            displayName: 'Asia Pacific (Singapore)',
                        },
                        {
                            id: 'ap-southeast-2',
                            value: 'ap-southeast-2',
                            displayName: 'Asia Pacific (Sydney)',
                        },
                        {
                            id: 'ap-south-1',
                            value: 'ap-south-1',
                            displayName: 'Asia Pacific (Mumbai)',
                        },
                        {
                            id: 'sa-east-1',
                            value: 'sa-east-1',
                            displayName: 'South America (São Paulo)',
                        },
                    ],
                },
                {
                    id: 'createdByName',
                    displayName: 'Created By',
                    required: false,
                    type: 'TEXT',
                    show: false,
                    copyToPayload: false,
                },
                {
                    id: 'createdOn',
                    displayName: 'Created Date',
                    required: false,
                    type: 'TEXT',
                    show: false,
                    decodingType: 'DATE',
                    copyToPayload: false,
                },
                {
                    id: 'lastUpdatedByName',
                    displayName: 'Modified By',
                    required: false,
                    type: 'TEXT',
                    show: false,
                    copyToPayload: false,
                },
                {
                    id: 'lastUpdatedOn',
                    displayName: 'Modified Date',
                    required: false,
                    type: 'TEXT',
                    show: false,
                    decodingType: 'DATE',
                    copyToPayload: false,
                },
            ],
        },
        {
            api: 'RESTAPI',
            canAddRecord: true,
            canTestConnection: false,
            canUpdateRecord: true,
            canDeleteRecord: true,
            canDownloadAuditTrail: true,
            displayName: 'Rest API',
            tableFieldIds: ['name', 'url', 'createdByName', 'createdOn', 'lastUpdatedByName', 'lastUpdatedOn'],
            fields: [
                {
                    id: 'name',
                    displayName: 'Name',
                    required: true,
                    inputTypeConditonal: false,
                    type: 'TEXT',
                    conditionalDisplay: false,
                    validations: [
                        'mustNotContainSpaces',
                        'maxLength250',
                        'minLength3',
                        'mustContainAlphabets',
                        'mustContainAlphaAsFirstLetter',
                    ],
                    conditionalDisable: [
                        {
                            type: 'ANY_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'id',
                                    valueExists: true,
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'authorizationSystem',
                    displayName: 'Authorization System',
                    required: true,
                    inputTypeConditonal: false,
                    type: 'OPTIONS',
                    options: [],
                    conditionalDisplay: false,
                    emitFirstEvent: true,
                    isFieldInConfiguredData: true,
                    callback: {
                        name: 'fetchAuthSystemsRequiredFields',
                        dependsOn: 'value',
                        subSectionId: 'authentication',
                        subFieldObject: 'authentication',
                        params: [],
                    },
                },
                {
                    id: 'restApiBaseUrl',
                    displayName: 'Base URL',
                    required: true,
                    inputTypeConditonal: false,
                    type: 'TEXT',
                    validations: ['checkUrl'],
                    conditionalDisplay: [
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'authorizationSystem',
                                    requiredValue: 'OTHERS',
                                },
                            ],
                        },
                    ],
                },

                {
                    id: 'createdByName',
                    displayName: 'Created By',
                    required: false,
                    type: 'TEXT',
                    show: false,
                    copyToPayload: false,
                },
                {
                    id: 'createdOn',
                    displayName: 'Created Date',
                    required: false,
                    type: 'TEXT',
                    show: false,
                    decodingType: 'DATE',
                    copyToPayload: false,
                },
                {
                    id: 'lastUpdatedByName',
                    displayName: 'Modified By',
                    required: false,
                    type: 'TEXT',
                    show: false,
                    copyToPayload: false,
                },
                {
                    id: 'lastUpdatedOn',
                    displayName: 'Modified Date',
                    required: false,
                    type: 'TEXT',
                    show: false,
                    decodingType: 'DATE',
                    copyToPayload: false,
                },
            ],
            subSections: [
                {
                    structure: 'POSTMAN',
                    haveTabs: true,
                    conditionalDisplay: [
                        {
                            type: 'ALL_MUST_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'authorizationSystem',
                                    requiredValue: 'OTHERS',
                                },
                            ],
                        },
                    ],
                    tabs: [
                        {
                            id: 'authentication',
                            displayName: 'Authentication',
                            array: false,
                            canAddRecord: false,
                            canDeleteRecord: false,
                            active: true,
                            fields: [
                                {
                                    id: 'type',
                                    displayName: 'Type',
                                    inputTypeConditonal: false,
                                    required: false,
                                    supportOptionsConfigProperty: 'supportedAuthenticationTypes',
                                    type: 'OPTIONS',
                                    options: [],
                                },
                                {
                                    id: 'grantType',
                                    displayName: 'Grant Types',
                                    required: true,
                                    conditionalDisplay: [
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                    ],
                                    type: 'OPTIONS',
                                    supportOptionsConfigProperty: 'supportedGrantTypes',
                                    options: [],
                                },
                                {
                                    id: 'callbackURL',
                                    displayName: 'Callback URL',
                                    required: false,
                                    conditionalDisplay: [
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Implicit',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Authorization Code',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                    ],
                                    type: 'TEXT',
                                },
                                {
                                    id: 'authorizationURL',
                                    displayName: 'Authorization URL',
                                    required: false,
                                    conditionalDisplay: [
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Authorization Code',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Implicit',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                    ],
                                    type: 'TEXT',
                                },
                                {
                                    id: 'accessTokenURL',
                                    displayName: 'Access Token URL',
                                    required: false,
                                    conditionalDisplay: [
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Authorization Code',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Password Credentials',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Client Credentials',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                    ],
                                    type: 'TEXT',
                                },
                                {
                                    id: 'clientId',
                                    displayName: 'Client ID',
                                    required: false,
                                    conditionalDisplay: [
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Authorization Code',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Implicit',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Password Credentials',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Client Credentials',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                    ],
                                    type: 'TEXT',
                                },
                                {
                                    id: 'clientSecret',
                                    displayName: 'Client Secret',
                                    required: false,
                                    conditionalDisplay: [
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Authorization Code',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Client Credentials',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Password Credentials',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                    ],
                                    type: 'PASSWORD',
                                },
                                {
                                    id: 'scope',
                                    displayName: 'Scope',
                                    required: false,
                                    conditionalDisplay: [
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Authorization Code',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Implicit',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Password Credentials',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Client Credentials',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                    ],
                                    type: 'TEXT',
                                },
                                {
                                    id: 'refreshTokenURL',
                                    displayName: 'Refresh Token URL',
                                    required: false,
                                    conditionalDisplay: [
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Authorization Code',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Implicit',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                    ],
                                    type: 'TEXT',
                                },
                                {
                                    id: 'clientAuthentication',
                                    displayName: 'Client Authentication',
                                    required: false,
                                    conditionalDisplay: [
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Authorization Code',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Implicit',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Password Credentials',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Client Credentials',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                    ],
                                    type: 'OPTIONS',
                                    supportOptionsConfigProperty: 'clientAuthentications',
                                    options: [],
                                },
                                {
                                    id: 'userName',
                                    displayName: 'User Name',
                                    required: true,
                                    conditionalDisplay: [
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'BASIC',
                                                },
                                            ],
                                        },
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Password Credentials',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'BASIC',
                                                },
                                            ],
                                        },
                                    ],
                                    type: 'PASSWORD',
                                },
                                {
                                    id: 'password',
                                    displayName: 'Password',
                                    required: true,
                                    conditionalDisplay: [
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'grantType',
                                                    requiredValue: 'Password Credentials',
                                                },
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'OAUTH',
                                                },
                                            ],
                                        },
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'BASIC',
                                                },
                                            ],
                                        },
                                    ],
                                    type: 'PASSWORD',
                                },
                                {
                                    type: 'TEXTAREA',
                                    id: 'customAuthenticationSchema',
                                    displayName: 'Authentication Schema',
                                    required: true,
                                    inputTypeConditonal: true,
                                    conditionalDisplay: [
                                        {
                                            type: 'ALL_MUST_SATISFY',
                                            conditions: [
                                                {
                                                    fieldId: 'type',
                                                    requiredValue: 'CUSTOMAUTH',
                                                },
                                            ],
                                        },
                                    ],
                                    encodingType: 'btoa',
                                    decodingType: 'atob',
                                    informationType: 'JSON',
                                    informationSnippetType: 'snippet',
                                    supportedInformationProperty: 'customAuthSchema',
                                    rows: 6,
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            api: 'EMAIL',
            canAddRecord: true,
            canTestConnection: false,
            canUpdateRecord: true,
            canDeleteRecord: true,
            canDownloadAuditTrail: true,
            displayName: 'Email',
            tableFieldIds: ['name', 'url', 'createdByName', 'createdOn', 'lastUpdatedByName', 'lastUpdatedOn'],
            fields: [
                {
                    id: 'name',
                    displayName: 'Name',
                    required: true,
                    inputTypeConditonal: false,
                    type: 'TEXT',
                    conditionalDisplay: false,
                    validations: [
                        'mustNotContainSpaces',
                        'maxLength250',
                        'minLength3',
                        'mustContainAlphabets',
                        'mustContainAlphaAsFirstLetter',
                    ],
                    conditionalDisable: [
                        {
                            type: 'ANY_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'id',
                                    valueExists: true,
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'authorizationSystem',
                    displayName: 'Authorization System',
                    required: true,
                    inputTypeConditonal: false,
                    type: 'OPTIONS',
                    options: [],
                    conditionalDisplay: false,
                },
                {
                    id: 'createdByName',
                    displayName: 'Created By',
                    required: false,
                    type: 'TEXT',
                    show: false,
                    copyToPayload: false,
                },
                {
                    id: 'createdOn',
                    displayName: 'Created Date',
                    required: false,
                    type: 'TEXT',
                    show: false,
                    decodingType: 'DATE',
                    copyToPayload: false,
                },
                {
                    id: 'lastUpdatedByName',
                    displayName: 'Modified By',
                    required: false,
                    type: 'TEXT',
                    show: false,
                    copyToPayload: false,
                },
                {
                    id: 'lastUpdatedOn',
                    displayName: 'Modified Date',
                    required: false,
                    type: 'TEXT',
                    show: false,
                    decodingType: 'DATE',
                    copyToPayload: false,
                },
            ],
            subSections: [],
        },
        {
            displayName: 'SharePoint',
            api: 'SHAREPOINT',
            tableFieldIds: ['name', 'createdByName', 'createdOn', 'lastUpdatedByName', 'lastUpdatedOn'],
            canAddRecord: true,
            canTestConnection: true,
            canUpdateRecord: true,
            canDeleteRecord: true,
            canDownloadAuditTrail: true,
            tableRecordActions: [],
            fields: [
                {
                    id: 'name',
                    displayName: 'Name',
                    required: true,
                    type: 'TEXT',
                    validations: ['maxLength250', 'minLength3', 'mustContainAlphabets', 'mustContainAlphaAsFirstLetter'],
                    conditionalDisable: [
                        {
                            type: 'ANY_SATISFY',
                            conditions: [
                                {
                                    fieldId: 'id',
                                    valueExists: true,
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'clientId',
                    displayName: 'Client ID',
                    required: true,
                    type: 'TEXT',
                },
                {
                    id: 'clientSecret',
                    displayName: 'Client Secret',
                    required: true,
                    type: 'PASSWORD',
                },
                {
                    id: 'tenantId',
                    displayName: 'Tenant ID',
                    required: true,
                    type: 'TEXT',
                },
                {
                    id: 'siteName',
                    displayName: 'Site Name',
                    required: true,
                    type: 'TEXT',
                },
                {
                    id: 'folderPath',
                    displayName: 'Folder Path',
                    required: true,
                    type: 'TEXT',
                    defaultValue: '/',
                },
                {
                    id: 'createdByName',
                    displayName: 'Created By',
                    required: false,
                    type: 'TEXT',
                    show: false,
                    copyToPayload: false,
                },
                {
                    id: 'createdOn',
                    displayName: 'Created Date',
                    required: false,
                    type: 'TEXT',
                    show: false,
                    decodingType: 'DATE',
                    copyToPayload: false,
                },
                {
                    id: 'lastUpdatedByName',
                    displayName: 'Modified By',
                    required: false,
                    type: 'TEXT',
                    show: false,
                    copyToPayload: false,
                },
                {
                    id: 'lastUpdatedOn',
                    displayName: 'Modified Date',
                    required: false,
                    type: 'TEXT',
                    show: false,
                    decodingType: 'DATE',
                    copyToPayload: false,
                },
            ],
        },
    ];

    inboundIntegrations: IntegrationModal = {
        api: 'inbound',
        canAddRecord: false,
        canTestConnection: true,
        useMaster: false,
        canUpdateRecord: true,
        displayName: 'Inbound Integration',
        tableFieldIds: [
            'configName',
            'chainName',
            'transformationName',
            'createdByUserName',
            'createdDate',
            'modifiedByUserName',
            'lastModifiedDate',
        ],
        tableHeaderNames: {
            chainName: 'Chain Name',
            transformationName: 'Transformation Name',
            createdByUserName: 'Created By User Name',
            createdDate: 'Created Date',
            modifiedByUserName: 'Modified By User Name',
            lastModifiedDate: 'Last Modified Date',
        },
        tableRecordActions: undefined,
        fields: [
            {
                array: false,
                displayName: 'Configuration Name',
                defaultValue: 'DefaultConfiguration',
                errors: [],
                id: 'configName',
                conditionalDisable: [
                    {
                        type: 'ANY_SATISFY',
                        conditions: [
                            {
                                fieldId: 'locationId',
                                valueExists: true,
                            },
                        ],
                    },
                ],
                options: [],
                required: true,
                type: 'TEXT',
                isFieldInMainDataOnly: true,
            },
            {
                array: false,
                displayName: 'Chain',
                errors: [],
                id: 'chainName',
                options: [],
                required: true,
                type: 'CHAIN_DROPDOWN',
                isFieldInMainDataOnly: true,
                conditionalDisable: [
                    {
                        type: 'ALL_MUST_SATISFY',
                        conditions: [
                            {
                                fieldId: 'locationId',
                                valueExists: true,
                            },
                            {
                                fieldId: 'chainName',
                                valueExists: true,
                            },
                        ],
                    },
                ],
            },
            {
                array: false,
                displayName: 'Transformation',
                errors: [],
                id: 'transformationName',
                options: [],
                required: true,
                type: 'TRANSFORMATIONS_DROPDOWN',
                isFieldInMainDataOnly: true,
                conditionalDisable: [
                    {
                        type: 'ALL_MUST_SATISFY',
                        conditions: [
                            {
                                fieldId: 'locationId',
                                valueExists: true,
                            },
                            {
                                fieldId: 'transformationName',
                                valueExists: true,
                            },
                        ],
                    },
                ],
            },
            {
                id: 'createdByUserName',
                displayName: 'Created By',
                required: false,
                type: 'TEXT',
                show: false,
                copyToPayload: false,
            },
            {
                id: 'createdDate',
                displayName: 'Created Date',
                required: false,
                type: 'TEXT',
                show: false,
                decodingType: 'DATE',
                copyToPayload: false,
            },
            {
                id: 'modifiedByUserName',
                displayName: 'Modified By',
                required: false,
                type: 'TEXT',
                show: false,
                copyToPayload: false,
            },
            {
                id: 'lastModifiedDate',
                displayName: 'Modified Date',
                required: false,
                type: 'TEXT',
                show: false,
                decodingType: 'DATE',
                copyToPayload: false,
            },
        ],
        subSections: [
            {
                displayName: 'Integration Methods for Sources',
                id: 'configs',
                structure: 'RECORDS_FORM',
                canAddRecord: true,
                canDeleteRecord: true,
                array: true,
                haveTabs: false,
                fields: [
                    {
                        array: false,
                        displayName: 'Source Name',
                        errors: [],
                        id: 'resourceName',
                        options: [],
                        uniqueValueInRecords: true,
                        required: true,
                        type: 'SOURCES_DROPDOWN',
                    },
                    {
                        array: false,
                        displayName: 'Integration Method',
                        errors: [],
                        id: 'integrationMethod',
                        options: [],
                        required: true,
                        type: 'API_CONFIG',
                    },
                    {
                        array: false,
                        displayName: 'Configuration',
                        errors: [],
                        id: 'globalConfigName',
                        options: [],
                        required: true,
                        type: 'API_CONFIGURED_LIST',
                        isFieldInConfiguredData: true,
                    },
                    {
                        array: false,
                        displayName: 'Organization Id',
                        errors: [],
                        id: 'orgId',
                        options: [],
                        required: false,
                        show: false,
                        type: 'TEXT',
                        isFieldInConfiguredData: true,
                    },
                    {
                        array: false,
                        displayName: 'Relative Folder Path',
                        errors: [],
                        id: 'relativePath',
                        options: [],
                        uniqueValueInRecords: true,
                        required: true,
                        type: 'TEXT',
                        isFieldInConfiguredData: true,
                        conditionalDisplay: [
                            {
                                type: 'ANY_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'FTP',
                                    },
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'S3',
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        array: false,
                        displayName: 'Folder Path',
                        errors: [],
                        id: 'folderPath',
                        options: [],
                        uniqueValueInRecords: true,
                        required: true,
                        type: 'TEXT',
                        isFieldInConfiguredData: true,
                        conditionalDisplay: [
                            {
                                type: 'ANY_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'SHAREPOINT',
                                    },
                                ],
                            },
                        ],
                        defaultValue: '/',
                        hint: 'Example: /Documents/Invoices/2026/',
                    },
                    {
                        id: 'fileNamePattern',
                        displayName: 'File Name Pattern',
                        required: false,
                        errors: [],
                        isFieldInConfiguredData: true,
                        conditionalDisplay: [
                            {
                                type: 'ANY_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'FTP',
                                    },
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'S3',
                                    },
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'SHAREPOINT',
                                    },
                                ],
                            },
                        ],
                        type: 'TEXT',
                        defaultValue: undefined,
                    },
                    {
                        array: false,
                        displayName: 'Checksum Verification',
                        id: 'checksumVerification',
                        required: false,
                        isFieldInConfiguredData: true,
                        conditionalDisplay: [
                            {
                                type: 'ANY_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'FTP',
                                    },
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'S3',
                                    },
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'SHAREPOINT',
                                    },
                                ],
                            },
                        ],
                        type: 'OPTIONS',
                        options: [
                            {
                                id: 'marker',
                                displayName: 'Marker',
                                value: 'marker',
                            },
                            {
                                id: 'checksumFile',
                                displayName: 'Checksum File',
                                value: 'checksumFile',
                            },
                        ],
                        errors: [],
                    },
                    {
                        array: false,
                        displayName: 'File Extension',
                        id: 'checksumFileExtension',
                        required: true,
                        conditionalDisplay: [
                            {
                                type: 'ANY_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'checksumVerification',
                                        requiredValue: 'marker',
                                    },
                                    {
                                        fieldId: 'checksumVerification',
                                        requiredValue: 'checksumFile',
                                    },
                                ],
                            },
                        ],
                        type: 'TEXT',
                        errors: [],
                        isFieldInConfiguredData: true,
                    },
                ],
                hasChildSubSectons: true,
                childSubSections: [
                    {
                        structure: 'HTTP',
                        haveTabs: false,
                        array: false,
                        conditionalDisplay: [
                            {
                                type: 'ANY_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'RESTAPI',
                                    },
                                ],
                            },
                        ],
                        fields: [
                            {
                                id: 'method',
                                displayName: 'Method',
                                errors: [],
                                required: true,
                                type: 'OPTIONS',
                                options: [
                                    {
                                        id: 'get',
                                        value: 'GET',
                                        displayName: this.translator('Get'),
                                    },
                                    {
                                        id: 'post',
                                        displayName: this.translator('Post'),
                                        value: 'POST',
                                    },
                                    {
                                        id: 'put',
                                        displayName: this.translator('Put'),
                                        value: 'PUT',
                                    },
                                ],
                                isFieldInConfiguredData: true,
                                uiType: 'HTTP-method',
                                defaultValue: 'GET',
                                tailwindClasses: ['rounded-r-none'],
                                hideHintElements: true,
                                appearance: 'outline',
                            },
                            {
                                id: 'url',
                                displayName: 'Relative Url',
                                required: false,
                                type: 'TEXT',
                                defaultValue: undefined,
                                errors: [],
                                isFieldInConfiguredData: true,
                                uiType: 'HTTP-url',
                                hideHintElements: true,
                                appearance: 'outline',
                                tailwindClasses: ['rounded-l-none', 'border-l-0'],
                            },
                        ],
                    },
                    {
                        structure: 'POSTMAN_NEW',
                        haveTabs: true,
                        conditionalDisplay: [
                            {
                                type: 'ALL_MUST_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'EMAIL',
                                    },
                                ],
                            },
                        ],
                        tabs: [
                            {
                                id: 'filters',
                                displayName: 'Filters',
                                array: true,
                                canAddRecord: true,
                                active: true,
                                isFieldInConfiguredData: true,
                                canDeleteRecord: true,
                                structure: 'TABLE',
                                fields: [
                                    {
                                        id: 'key',
                                        displayName: 'Key',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'OPTIONS',
                                        required: false,
                                        isUnique: true,
                                        position: 'COLUMN',
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                        supportOptionsConfigProperty: 'emailFilterKeys',
                                    },
                                    {
                                        id: 'values',
                                        displayName: 'Value',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'TEXT',
                                        required: false,
                                        position: 'COLUMN',
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        structure: 'POSTMAN_NEW',
                        haveTabs: true,
                        conditionalDisplay: [
                            {
                                type: 'ALL_MUST_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'RESTAPI',
                                    },
                                ],
                            },
                        ],
                        tabs: [
                            {
                                id: 'headers',
                                displayName: 'Header',
                                array: true,
                                canAddRecord: true,
                                active: true,
                                isFieldInConfiguredData: true,
                                canDeleteRecord: true,
                                structure: 'TABLE',
                                fields: [
                                    {
                                        id: 'key',
                                        displayName: 'Key',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'TEXT',
                                        required: false,
                                        isUnique: true,
                                        position: 'COLUMN',
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'values',
                                        displayName: 'Value',
                                        valueAsArrayInPayload: true,
                                        conditionalDisplay: false,
                                        inputTypeConditonal: true,
                                        type: 'TEXT',
                                        required: false,
                                        position: 'COLUMN',
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                ],
                                recordActions: [],
                            },
                            {
                                id: 'body',
                                displayName: 'Body',
                                array: false,
                                canAddRecord: false,
                                active: false,
                                isFieldInConfiguredData: true,
                                noSubObjectForFields: true,
                                canDeleteRecord: false,
                                fields: [
                                    {
                                        id: 'language',
                                        displayName: 'Language',
                                        show: false,
                                        copyToPayload: false,
                                        conditionalDisplay: false,
                                        type: 'INPUT_RADIO',
                                        defaultValueIf: [
                                            {
                                                type: 'ALL_MUST_SATISFY',
                                                defaultValue: 'raw',
                                                conditions: [
                                                    {
                                                        fieldId: 'content',
                                                        valueExists: true,
                                                    },
                                                ],
                                            },
                                            {
                                                type: 'ALL_MUST_SATISFY',
                                                defaultValue: 'graphql',
                                                conditions: [
                                                    {
                                                        fieldId: 'query',
                                                        valueExists: true,
                                                    },
                                                    {
                                                        fieldId: 'variables',
                                                        valueExists: true,
                                                    },
                                                ],
                                            },
                                            {
                                                type: 'ALL_MUST_SATISFY',
                                                defaultValue: 'jsonrpc',
                                                conditions: [
                                                    {
                                                        fieldId: 'jsonRpcMethod',
                                                        valueExists: true,
                                                    },
                                                    {
                                                        fieldId: 'jsonRpcParams',
                                                        valueExists: true,
                                                    },
                                                ],
                                            },
                                            {
                                                type: 'ALL_MUST_SATISFY',
                                                defaultValue: 'formUrlEncodedParams',
                                                conditions: [
                                                    {
                                                        fieldId: 'formUrlEncodedParams',
                                                        valueExists: true,
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        id: 'type',
                                        displayName: 'Body Type',
                                        required: false,
                                        show: false,
                                        copyToPayload: true,
                                        conditionalDisplay: false,
                                        options: [
                                            {
                                                id: 'text',
                                                displayName: 'TEXT',
                                                value: 'Text',
                                            },
                                            {
                                                id: 'json',
                                                displayName: 'JSON',
                                                value: 'JSON',
                                            },
                                            {
                                                id: 'xml',
                                                displayName: 'XML',
                                                value: 'XML',
                                            },
                                        ],
                                        tailwindClasses: ['border-0', 'py-0', 'w-[auto]', 'text-taxillaGreen'],
                                        hideHintElements: true,
                                        type: 'BODY_TYPE',
                                    },
                                    {
                                        id: 'content',
                                        displayName: 'Raw Text',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'BODY_EDITOR',

                                        required: false,
                                    },
                                    {
                                        id: 'query',
                                        displayName: 'Query',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'QUERY_EDITOR',
                                        required: false,
                                        show: false,
                                        copyToPayload: true,
                                    },
                                    {
                                        id: 'variables',
                                        displayName: 'Variables',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'VARIABLES_EDITOR',
                                        required: false,
                                        show: false,
                                        copyToPayload: true,
                                        encodingType: 'JSON',
                                        decodingType: 'STRING',
                                    },
                                    {
                                        id: 'jsonRpcMethod',
                                        displayName: 'Json Rpc Method',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'JSON_RPC_METHOD',
                                        required: false,
                                        show: false,
                                        copyToPayload: true,
                                    },
                                    {
                                        id: 'jsonRpcParams',
                                        displayName: 'Json Rpc Params',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'JSON_RPC_PARAMS',
                                        required: false,
                                        show: false,
                                        copyToPayload: true,
                                        encodingType: 'JSON',
                                        decodingType: 'STRING',
                                    },
                                ],
                                conditionallyDisable: true,
                                disableConditions: [
                                    {
                                        type: 'ANY_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'method',
                                                requiredValue: 'GET',
                                            },
                                        ],
                                    },
                                ],
                                childSubSections: [
                                    {
                                        id: 'formUrlEncodedParams',
                                        structure: 'TABLE',
                                        array: true,
                                        isObject: true,
                                        keyFieldId: 'key',
                                        valueFieldId: 'value',
                                        haveTabs: false,
                                        conditionalDisplay: [
                                            {
                                                type: 'ANY_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'language',
                                                        requiredValue: 'formUrlEncodedParams',
                                                    },
                                                ],
                                            },
                                        ],
                                        fields: [
                                            {
                                                id: 'key',
                                                displayName: 'Key',
                                                conditionalDisplay: false,
                                                inputTypeConditonal: false,
                                                type: 'TEXT',
                                                required: false,
                                                show: true,
                                                copyToPayload: true,
                                                position: 'COLUMN',
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0'],
                                            },
                                            {
                                                id: 'value',
                                                displayName: 'Value',
                                                conditionalDisplay: false,
                                                inputTypeConditonal: true,
                                                type: 'TEXT',
                                                required: false,
                                                show: true,
                                                copyToPayload: true,
                                                position: 'COLUMN',
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0'],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                id: 'queryParams',
                                displayName: 'Query Params',
                                array: true,
                                isFieldInConfiguredData: true,
                                canAddRecord: true,
                                canDeleteRecord: true,
                                structure: 'TABLE',
                                fields: [
                                    {
                                        id: 'key',
                                        displayName: 'Key',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'TEXT',
                                        required: false,
                                        isUnique: true,
                                        position: 'COLUMN',
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'values',
                                        displayName: 'Value',
                                        valueAsArrayInPayload: true,
                                        conditionalDisplay: false,
                                        inputTypeConditonal: true,
                                        type: [
                                            {
                                                fieldId: 'dynamicExp',
                                                requiredValue: true,
                                                type: 'OPTIONS',
                                            },
                                            {
                                                fieldId: 'dynamicExp',
                                                requiredValue: false,
                                                type: 'TEXT',
                                            },
                                        ],
                                        required: false,
                                        position: 'COLUMN',
                                        options: [
                                            {
                                                displayName: 'Current Month',
                                                id: 'currentMonth',
                                                value: 'm',
                                            },
                                            {
                                                displayName: 'Current Year',
                                                id: 'currentYear',
                                                value: 'y',
                                            },
                                            {
                                                displayName: 'Current Date',
                                                id: 'currentDate',
                                                value: 'd',
                                            },
                                            {
                                                displayName: 'Beginning of Month',
                                                id: 'beginningOfMonth',
                                                value: 'bom',
                                            },
                                            {
                                                displayName: 'End of Month',
                                                id: 'endOfMonth',
                                                value: 'eom',
                                            },
                                            {
                                                displayName: 'Scheduler from Date',
                                                id: 'schedulerFromDate',
                                                value: 'schedular_from_date',
                                            },
                                            {
                                                displayName: 'Scheduler to Date',
                                                id: 'schedulerToDate',
                                                value: 'schedular_to_date',
                                            },
                                            {
                                                displayName: 'Other',
                                                id: 'other',
                                                value: 'other',
                                            },
                                        ],
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                ],
                                recordActions: [],
                            },
                            {
                                id: 'placeHolderMappings',
                                displayName: 'PlaceHolder Mappings',
                                array: true,
                                isObject: true,
                                keyFieldId: 'key',
                                active: false,
                                isFieldInConfiguredData: false,
                                placHolderMapping: true,
                                structure: 'TABLE',
                                fields: [
                                    {
                                        id: 'key',
                                        displayName: 'Key',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'TEXT',
                                        required: false,
                                        position: 'COLUMN',
                                        isUnique: true,
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'autoGenerate',
                                        displayName: 'Auto Generate',
                                        required: true,
                                        array: false,
                                        conditionalDisable: [
                                            {
                                                type: 'ANY_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'key',
                                                        valueExists: false,
                                                    },
                                                ],
                                            },
                                        ],
                                        isMasterField: true,
                                        defaultValue: false,
                                        position: 'COLUMN',
                                        placeHolderMapping: true,
                                        isFieldInConfiguredData: false,
                                        type: 'CHECKBOX',
                                        hideLabel: true,
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'dynamicParamsKey',
                                        displayName: 'Dynamic Params Key',
                                        required: false,
                                        type: 'DYNAMIC_PARAMS_DROPDOWN',
                                        isFieldInConfiguredData: false,
                                        options: [],
                                        validations: ['checkValueExists'],
                                        errors: [],
                                        array: false,
                                        position: 'COLUMN',
                                        placeHolderMapping: true,
                                        conditionalDisable: [
                                            {
                                                type: 'ANY_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'key',
                                                        valueExists: false,
                                                    },
                                                    {
                                                        fieldId: 'autoGenerate',
                                                        requiredValue: false,
                                                    },
                                                ],
                                            },
                                        ],
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                        supportOptionsConfigProperty: 'dynamicParamsKeys',
                                    },
                                    {
                                        id: 'fieldType',
                                        displayName: 'Field Type',
                                        required: false,
                                        type: 'TEXT',
                                        isFieldInConfiguredData: false,
                                        options: [],
                                        validations: ['checkValueExists'],
                                        errors: [],
                                        array: false,
                                        position: 'COLUMN',
                                        placeHolderMapping: true,
                                        disabled: true,
                                        copyToPayload: false,
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'dateFormat',
                                        displayName: 'Date Format',
                                        required: false,
                                        type: 'TEXT',
                                        defaultValue: 'DD-MM-YYYY',
                                        errors: [],
                                        isFieldInConfiguredData: false,
                                        placeHolderMapping: true,
                                        position: 'COLUMN',
                                        conditionalDisable: [
                                            {
                                                type: 'ANY_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'key',
                                                        valueExists: false,
                                                    },
                                                    {
                                                        fieldId: 'autoGenerate',
                                                        requiredValue: false,
                                                    },
                                                    {
                                                        fieldId: 'fieldType',
                                                        requiredValue: 'SYSTEM',
                                                    },
                                                ],
                                            },
                                        ],
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'replacementPlaceHolderKey',
                                        displayName: 'Replacement Key',
                                        required: false,
                                        defaultValue: undefined,
                                        errors: [],
                                        isFieldInConfiguredData: false,
                                        position: 'COLUMN',
                                        placeHolderMapping: true,
                                        conditionalDisable: [
                                            {
                                                type: 'ANY_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'key',
                                                        valueExists: false,
                                                    },
                                                    {
                                                        fieldId: 'autoGenerate',
                                                        requiredValue: true,
                                                    },
                                                ],
                                            },
                                        ],
                                        type: 'TEXT',
                                        hideLabel: true,
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'additionalFieldRequired',
                                        displayName: 'Additional Field Required',
                                        show: true,
                                        required: false,
                                        position: 'COLUMN',
                                        type: 'CHECKBOX',
                                        hideLabel: true,
                                        placeHolderMapping: true,
                                        disabled: true,
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'offsetValue',
                                        displayName: 'Offset Value',
                                        required: false,
                                        type: 'TEXT',
                                        isFieldInConfiguredData: false,
                                        options: [],
                                        validations: ['checkValueExists'],
                                        errors: [],
                                        array: false,
                                        position: 'COLUMN',
                                        placeHolderMapping: true,
                                        conditionalDisable: [
                                            {
                                                type: 'ANY_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'key',
                                                        valueExists: false,
                                                    },
                                                    {
                                                        fieldId: 'additionalFieldRequired',
                                                        requiredValue: false,
                                                    },
                                                    {
                                                        fieldId: 'additionalFieldRequired',
                                                        requiredValue: undefined,
                                                    },
                                                ],
                                            },
                                        ],
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        haveTabs: false,
                        structure: 'RECORD_FORM',
                        array: false,
                        conditionalDisplay: [
                            {
                                type: 'ANY_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'RESTAPI',
                                    },
                                ],
                            },
                        ],
                        fields: [
                            {
                                id: 'async',
                                displayName: 'Async',
                                required: false,
                                array: false,
                                isMasterField: true,
                                defaultValue: false,
                                type: 'INPUT_RADIO',
                                options: [
                                    {
                                        id: 'yes',
                                        displayName: 'Yes',
                                        value: true,
                                    },
                                    {
                                        id: 'no',
                                        displayName: 'No',
                                        value: false,
                                    },
                                ],
                            },
                            {
                                id: 'internal',
                                displayName: 'Internal',
                                required: false,
                                array: false,
                                isMasterField: true,
                                defaultValue: false,
                                type: 'INPUT_RADIO',
                                options: [
                                    {
                                        id: 'yes',
                                        displayName: 'Yes',
                                        value: true,
                                    },
                                    {
                                        id: 'no',
                                        displayName: 'No',
                                        value: false,
                                    },
                                ],
                            },
                            {
                                id: 'internalConfig',
                                displayName: 'Internal Config',
                                required: true,
                                type: 'INTERNALCONFIG_DROPDOWN',
                                supportOptionsConfigProperty: 'internalConfig',
                                options: [],
                                errors: [],
                                array: false,
                                conditionalDisplay: [
                                    {
                                        type: 'ANY_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'async',
                                                requiredValue: true,
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                id: 'internalRetryCount',
                                displayName: 'Internal Retry Count',
                                required: true,
                                type: 'TEXT',
                                isFieldInConfiguredData: false,
                                validations: ['checkInteger', 'checkMinimumNumberValue'],
                                errors: [],
                                array: false,
                                conditionalDisplay: [
                                    {
                                        type: 'ANY_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'internal',
                                                requiredValue: true,
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                id: 'internalSchedulerInterval',
                                displayName: 'Internal Scheduler Interval (seconds)',
                                required: true,
                                type: 'TEXT',
                                isFieldInConfiguredData: false,
                                validations: ['checkInteger', 'checkMinimumNumberValue'],
                                errors: [],
                                array: false,
                                conditionalDisplay: [
                                    {
                                        type: 'ANY_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'internal',
                                                requiredValue: true,
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                id: 'responseType',
                                displayName: 'Response Type',
                                required: false,
                                errors: [],
                                isFieldInConfiguredData: true,
                                type: 'OPTIONS',
                                defaultValue: undefined,
                                supportOptionsConfigProperty: 'restApiResponseType',
                                options: [],
                            },
                            {
                                id: 'urlKey',
                                displayName: 'URL Key',
                                required: true,
                                errors: [],
                                isFieldInConfiguredData: true,
                                conditionalDisplay: [
                                    {
                                        type: 'ANY_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'responseType',
                                                requiredValue: 'URL',
                                            },
                                        ],
                                    },
                                ],
                                type: 'TEXT',
                            },
                            {
                                id: 'paginationEnabled',
                                displayName: 'Pagination Enabled',
                                required: false,
                                array: false,
                                isMasterField: true,
                                defaultValue: false,
                                type: 'INPUT_RADIO',
                                options: [
                                    {
                                        id: 'yes',
                                        displayName: 'Yes',
                                        value: true,
                                    },
                                    {
                                        id: 'no',
                                        displayName: 'No',
                                        value: false,
                                    },
                                ],
                            },
                            {
                                type: 'TEXTAREA',
                                id: 'paginationSchema',
                                displayName: 'Pagination Schema',
                                required: true,
                                inputTypeConditonal: true,
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'paginationEnabled',
                                                requiredValue: true,
                                            },
                                        ],
                                    },
                                ],
                                informationType: 'JSON',
                                informationSnippetType: 'snippet',
                                supportedInformationProperty: 'paginationSchema',
                                rows: 6,
                            },
                            {
                                id: 'isFanoutRequest',
                                displayName: 'Is Fanout Request',
                                required: false,
                                array: false,
                                defaultValue: false,
                                type: 'INPUT_RADIO',
                                options: [
                                    {
                                        id: 'yes',
                                        displayName: 'Yes',
                                        value: true,
                                    },
                                    {
                                        id: 'no',
                                        displayName: 'No',
                                        value: false,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                displayName: 'Scheduler Details',
                structure: 'FORM',
                haveTabs: false,
                conditionalDisplay: [
                    {
                        type: 'ANY_SATISFY',
                        conditions: [
                            {
                                fieldId: 'internal',
                                requiredValue: false,
                            },
                            {
                                fieldId: 'internal',
                                valueExists: false,
                            },
                        ],
                    },
                ],
                fields: [
                    {
                        displayName: 'Trigger Job',
                        id: 'triggerJob',
                        array: false,
                        defaultValue: false,
                        required: true,
                        type: 'INPUT_RADIO',
                        options: [
                            {
                                id: 'yes',
                                displayName: 'Yes',
                                value: true,
                            },
                            {
                                id: 'no',
                                displayName: 'No',
                                value: false,
                            },
                        ],
                        errors: [],
                        hideLabel: false,
                        inputTypeConditonal: true,
                    },
                ],
            },
            {
                structure: 'FLEX_FORM',
                id: 'schedulerExpression',
                appendType: 'cronExpression',
                haveTabs: false,
                conditionalDisplay: [
                    {
                        type: 'ALL_MUST_SATISFY',
                        conditions: [
                            {
                                fieldId: 'triggerJob',
                                requiredValue: true,
                            },
                        ],
                    },
                ],
                fields: [
                    {
                        displayName: 'Cron Expression',
                        id: 'schedulerExpression',
                        array: false,
                        defaultValue: '0 10 1 1 ?',
                        required: true,
                        type: 'TEXT',
                        errors: [],
                        hideLabel: false,
                        inputTypeConditonal: true,
                    },
                ],
            },
        ],
        fieldsToRemoveFromResponse: ['config.integrationSettings', 'config.method'],
    };

    mastersScheduler: IntegrationModal = mastersScheduler;

    outboundIntegrations: IntegrationModal = {
        api: 'outbound',
        canAddRecord: false,
        canTestConnection: true,
        canUpdateRecord: true,
        useMaster: false,
        displayName: 'Outbound Integration',
        tableFieldIds: [
            'configName',
            'chainName',
            'transformationName',
            'active',
            'createdByUserName',
            'createdDate',
            'modifiedByUserName',
            'lastModifiedDate',
        ],
        tableHeaderNames: {
            chainName: 'Chain Name',
            transformationName: 'Transformation Name',
            createdByUserName: 'Created By User Name',
            createdDate: 'Created Date',
            modifiedByUserName: 'Modified By User Name',
            lastModifiedDate: 'Last Modified Date',
        },
        tableRecordActions: undefined,
        fields: [
            {
                array: false,
                displayName: 'Configuration Name',
                errors: [],
                id: 'configName',
                defaultValue: 'DefaultConfiguration',
                conditionalDisable: [
                    {
                        type: 'ANY_SATISFY',
                        conditions: [
                            {
                                fieldId: 'locationId',
                                valueExists: true,
                            },
                        ],
                    },
                ],
                options: [],
                required: true,
                type: 'TEXT',
                isFieldInMainDataOnly: true,
            },
            {
                array: false,
                displayName: 'Chain',
                errors: [],
                id: 'chainName',
                options: [],
                required: true,
                type: 'CHAIN_DROPDOWN',
                isFieldInMainDataOnly: true,
                conditionalDisable: [
                    {
                        type: 'ALL_MUST_SATISFY',
                        conditions: [
                            {
                                fieldId: 'locationId',
                                valueExists: true,
                            },
                            {
                                fieldId: 'chainName',
                                valueExists: true,
                            },
                        ],
                    },
                ],
            },
            {
                array: false,
                displayName: 'Transformation',
                errors: [],
                id: 'transformationName',
                options: [],
                required: true,
                type: 'TRANSFORMATIONS_DROPDOWN',
                isFieldInMainDataOnly: true,
                conditionalDisable: [
                    {
                        type: 'ALL_MUST_SATISFY',
                        conditions: [
                            {
                                fieldId: 'locationId',
                                valueExists: true,
                            },
                            {
                                fieldId: 'transformationName',
                                valueExists: true,
                            },
                        ],
                    },
                ],
            },
            {
                id: 'createdByUserName',
                displayName: 'Created By',
                required: false,
                type: 'TEXT',
                show: false,
                copyToPayload: false,
            },
            {
                id: 'createdDate',
                displayName: 'Created Date',
                required: false,
                type: 'TEXT',
                show: false,
                decodingType: 'DATE',
                copyToPayload: false,
            },
            {
                id: 'modifiedByUserName',
                displayName: 'Modified By',
                required: false,
                type: 'TEXT',
                show: false,
                copyToPayload: false,
            },
            {
                id: 'lastModifiedDate',
                displayName: 'Modified Date',
                required: false,
                type: 'TEXT',
                show: false,
                decodingType: 'DATE',
                copyToPayload: false,
            },
        ],
        subSections: [
            {
                displayName: 'Integration Methods for Sources',
                id: 'configs',
                structure: 'RECORDS_FORM',
                canAddRecord: true,
                canDeleteRecord: true,
                array: true,
                haveTabs: false,
                fields: [
                    {
                        array: false,
                        displayName: 'Source Name',
                        errors: [],
                        id: 'resourceName',
                        options: [],
                        uniqueValueInRecords: true,
                        required: false,
                        type: 'SOURCES_DROPDOWN',
                        show: false,
                        valueSameAsFieldId: 'transformationName',
                    },
                    {
                        array: false,
                        displayName: 'Integration Method',
                        errors: [],
                        id: 'integrationMethod',
                        options: [],
                        required: true,
                        type: 'API_CONFIG',
                    },
                    {
                        array: false,
                        displayName: 'Configuration',
                        errors: [],
                        id: 'globalConfigName',
                        options: [],
                        required: true,
                        type: 'API_CONFIGURED_LIST',
                        isFieldInConfiguredData: true,
                    },
                    {
                        array: false,
                        displayName: 'Organization Id',
                        errors: [],
                        id: 'orgId',
                        options: [],
                        required: false,
                        show: false,
                        type: 'TEXT',
                        isFieldInConfiguredData: true,
                    },
                    {
                        array: false,
                        displayName: 'Relative Folder Path',
                        errors: [],
                        id: 'relativePath',
                        options: [],
                        uniqueValueInRecords: true,
                        required: true,
                        type: 'TEXT',
                        isFieldInConfiguredData: true,
                        conditionalDisplay: [
                            {
                                type: 'ANY_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'FTP',
                                    },
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'S3',
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        array: false,
                        displayName: 'Folder Path',
                        errors: [],
                        id: 'folderPath',
                        options: [],
                        uniqueValueInRecords: true,
                        required: true,
                        type: 'TEXT',
                        isFieldInConfiguredData: true,
                        conditionalDisplay: [
                            {
                                type: 'ANY_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'SHAREPOINT',
                                    },
                                ],
                            },
                        ],
                        defaultValue: '/',
                        hint: 'Example: /Documents/Invoices/2026/',
                    },
                    {
                        array: false,
                        displayName: 'Checksum Verification',
                        id: 'checksumVerification',
                        required: false,
                        isFieldInConfiguredData: true,
                        conditionalDisplay: [
                            {
                                type: 'ANY_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'FTP',
                                    },
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'S3',
                                    },
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'SHAREPOINT',
                                    },
                                ],
                            },
                        ],
                        type: 'OPTIONS',
                        options: [
                            {
                                id: 'marker',
                                displayName: 'Marker',
                                value: 'marker',
                            },
                            {
                                id: 'checksumFile',
                                displayName: 'Checksum File',
                                value: 'checksumFile',
                            },
                        ],
                        errors: [],
                    },
                    {
                        array: false,
                        displayName: 'File Extension',
                        id: 'checksumFileExtension',
                        required: true,
                        conditionalDisplay: [
                            {
                                type: 'ANY_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'checksumVerification',
                                        requiredValue: 'marker',
                                    },
                                    {
                                        fieldId: 'checksumVerification',
                                        requiredValue: 'checksumFile',
                                    },
                                ],
                            },
                        ],
                        type: 'TEXT',
                        errors: [],
                        isFieldInConfiguredData: true,
                    },
                ],
                hasChildSubSectons: true,
                childSubSections: [
                    {
                        structure: 'HTTP',
                        haveTabs: false,
                        array: false,
                        conditionalDisplay: [
                            {
                                type: 'ANY_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'RESTAPI',
                                    },
                                ],
                            },
                        ],
                        fields: [
                            {
                                id: 'method',
                                displayName: 'Method',
                                errors: [],
                                required: true,
                                type: 'OPTIONS',
                                options: [
                                    {
                                        id: 'post',
                                        displayName: this.translator('Post'),
                                        value: 'POST',
                                    },
                                    {
                                        id: 'put',
                                        displayName: this.translator('Put'),
                                        value: 'PUT',
                                    },
                                ],
                                isFieldInConfiguredData: true,
                                uiType: 'HTTP-method',
                                defaultValue: 'POST',
                                tailwindClasses: ['rounded-r-none'],
                                hideHintElements: true,
                                appearance: 'outline',
                            },
                            {
                                id: 'url',
                                displayName: 'Relative Url',
                                required: false,
                                type: 'TEXT',
                                defaultValue: undefined,
                                errors: [],
                                isFieldInConfiguredData: true,
                                uiType: 'HTTP-url',
                                hideHintElements: true,
                                appearance: 'outline',
                                tailwindClasses: ['rounded-l-none', 'border-l-0'],
                            },
                        ],
                    },
                    {
                        structure: 'POSTMAN_NEW',
                        haveTabs: true,
                        conditionalDisplay: [
                            {
                                type: 'ALL_MUST_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'RESTAPI',
                                    },
                                ],
                            },
                        ],
                        tabs: [
                            {
                                id: 'headers',
                                displayName: 'Header',
                                array: true,
                                canAddRecord: true,
                                active: true,
                                isFieldInConfiguredData: true,
                                canDeleteRecord: true,
                                structure: 'TABLE',
                                fields: [
                                    {
                                        id: 'key',
                                        displayName: 'Key',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'TEXT',
                                        required: false,
                                        isUnique: true,
                                        position: 'COLUMN',
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'values',
                                        displayName: 'Value',
                                        valueAsArrayInPayload: true,
                                        conditionalDisplay: false,
                                        inputTypeConditonal: true,
                                        type: 'TEXT',
                                        required: false,
                                        position: 'COLUMN',
                                        options: [
                                            {
                                                displayName: 'Current Month',
                                                id: 'currentMonth',
                                                value: 'm',
                                            },
                                            {
                                                displayName: 'Current Year',
                                                id: 'currentYear',
                                                value: 'y',
                                            },
                                            {
                                                displayName: 'Current Date',
                                                id: 'currentDate',
                                                value: 'd',
                                            },
                                            {
                                                displayName: 'Beginning of Month',
                                                id: 'beginningOfMonth',
                                                value: 'bom',
                                            },
                                            {
                                                displayName: 'End of Month',
                                                id: 'endOfMonth',
                                                value: 'eom',
                                            },
                                            {
                                                displayName: 'Scheduler from Date',
                                                id: 'schedulerFromDate',
                                                value: 'schedular_from_date',
                                            },
                                            {
                                                displayName: 'Scheduler to Date',
                                                id: 'schedulerToDate',
                                                value: 'schedular_to_date',
                                            },
                                            {
                                                displayName: 'Other',
                                                id: 'other',
                                                value: 'other',
                                            },
                                        ],
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                ],
                                recordActions: [],
                            },
                            {
                                id: 'queryParams',
                                displayName: 'Query Params',
                                array: true,
                                isFieldInConfiguredData: true,
                                canAddRecord: true,
                                canDeleteRecord: true,
                                structure: 'TABLE',
                                fields: [
                                    {
                                        id: 'key',
                                        displayName: 'Key',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'TEXT',
                                        required: false,
                                        isUnique: true,
                                        position: 'COLUMN',
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'values',
                                        displayName: 'Value',
                                        valueAsArrayInPayload: true,
                                        conditionalDisplay: false,
                                        inputTypeConditonal: true,
                                        type: [
                                            {
                                                fieldId: 'dynamicExp',
                                                requiredValue: true,
                                                type: 'OPTIONS',
                                            },
                                            {
                                                fieldId: 'dynamicExp',
                                                requiredValue: false,
                                                type: 'TEXT',
                                            },
                                        ],
                                        required: false,
                                        position: 'COLUMN',
                                        options: [
                                            {
                                                displayName: 'Current Month',
                                                id: 'currentMonth',
                                                value: 'm',
                                            },
                                            {
                                                displayName: 'Current Year',
                                                id: 'currentYear',
                                                value: 'y',
                                            },
                                            {
                                                displayName: 'Current Date',
                                                id: 'currentDate',
                                                value: 'd',
                                            },
                                            {
                                                displayName: 'Beginning of Month',
                                                id: 'beginningOfMonth',
                                                value: 'bom',
                                            },
                                            {
                                                displayName: 'End of Month',
                                                id: 'endOfMonth',
                                                value: 'eom',
                                            },
                                            {
                                                displayName: 'Scheduler from Date',
                                                id: 'schedulerFromDate',
                                                value: 'schedular_from_date',
                                            },
                                            {
                                                displayName: 'Scheduler to Date',
                                                id: 'schedulerToDate',
                                                value: 'schedular_to_date',
                                            },
                                            {
                                                displayName: 'Other',
                                                id: 'other',
                                                value: 'other',
                                            },
                                        ],
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                ],
                                recordActions: [],
                            },
                            {
                                id: 'placeHolderMappings',
                                displayName: 'PlaceHolder Mappings',
                                array: true,
                                isObject: true,
                                keyFieldId: 'key',
                                active: false,
                                isFieldInConfiguredData: false,
                                placHolderMapping: true,
                                structure: 'TABLE',
                                fields: [
                                    {
                                        id: 'key',
                                        displayName: 'Key',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'TEXT',
                                        required: false,
                                        position: 'COLUMN',
                                        isUnique: true,
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'autoGenerate',
                                        displayName: 'Auto Generate',
                                        required: true,
                                        array: false,
                                        conditionalDisable: [
                                            {
                                                type: 'ANY_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'key',
                                                        valueExists: false,
                                                    },
                                                ],
                                            },
                                        ],
                                        isMasterField: true,
                                        defaultValue: false,
                                        position: 'COLUMN',
                                        placeHolderMapping: true,
                                        isFieldInConfiguredData: false,
                                        type: 'CHECKBOX',
                                        hideLabel: true,
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'dynamicParamsKey',
                                        displayName: 'Dynamic Params Key',
                                        required: false,
                                        type: 'DYNAMIC_PARAMS_DROPDOWN',
                                        isFieldInConfiguredData: false,
                                        options: [],
                                        validations: ['checkValueExists'],
                                        errors: [],
                                        array: false,
                                        position: 'COLUMN',
                                        placeHolderMapping: true,
                                        conditionalDisable: [
                                            {
                                                type: 'ANY_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'key',
                                                        valueExists: false,
                                                    },
                                                    {
                                                        fieldId: 'autoGenerate',
                                                        requiredValue: false,
                                                    },
                                                ],
                                            },
                                        ],
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                        supportOptionsConfigProperty: 'dynamicParamsKeys',
                                    },
                                    {
                                        id: 'fieldType',
                                        displayName: 'Field Type',
                                        required: false,
                                        type: 'TEXT',
                                        isFieldInConfiguredData: false,
                                        options: [],
                                        validations: ['checkValueExists'],
                                        errors: [],
                                        array: false,
                                        position: 'COLUMN',
                                        placeHolderMapping: true,
                                        disabled: true,
                                        copyToPayload: false,
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'dateFormat',
                                        displayName: 'Date Format',
                                        required: false,
                                        type: 'TEXT',
                                        defaultValue: 'DD-MM-YYYY',
                                        errors: [],
                                        isFieldInConfiguredData: false,
                                        placeHolderMapping: true,
                                        position: 'COLUMN',
                                        conditionalDisable: [
                                            {
                                                type: 'ANY_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'key',
                                                        valueExists: false,
                                                    },
                                                    {
                                                        fieldId: 'autoGenerate',
                                                        requiredValue: false,
                                                    },
                                                    {
                                                        fieldId: 'fieldType',
                                                        requiredValue: 'SYSTEM',
                                                    },
                                                ],
                                            },
                                        ],
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'replacementPlaceHolderKey',
                                        displayName: 'Replacement Key',
                                        required: false,
                                        defaultValue: undefined,
                                        errors: [],
                                        isFieldInConfiguredData: false,
                                        position: 'COLUMN',
                                        placeHolderMapping: true,
                                        conditionalDisable: [
                                            {
                                                type: 'ANY_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'key',
                                                        valueExists: false,
                                                    },
                                                    {
                                                        fieldId: 'autoGenerate',
                                                        requiredValue: true,
                                                    },
                                                ],
                                            },
                                        ],
                                        type: 'TEXT',
                                        hideLabel: true,
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'additionalFieldRequired',
                                        displayName: 'Additional Field Required',
                                        show: true,
                                        required: false,
                                        position: 'COLUMN',
                                        type: 'CHECKBOX',
                                        hideLabel: true,
                                        placeHolderMapping: true,
                                        disabled: true,
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'offsetValue',
                                        displayName: 'Offset Value',
                                        required: false,
                                        type: 'TEXT',
                                        isFieldInConfiguredData: false,
                                        options: [],
                                        validations: ['checkValueExists'],
                                        errors: [],
                                        array: false,
                                        position: 'COLUMN',
                                        placeHolderMapping: true,
                                        conditionalDisable: [
                                            {
                                                type: 'ANY_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'key',
                                                        valueExists: false,
                                                    },
                                                    {
                                                        fieldId: 'additionalFieldRequired',
                                                        requiredValue: false,
                                                    },
                                                    {
                                                        fieldId: 'additionalFieldRequired',
                                                        requiredValue: undefined,
                                                    },
                                                ],
                                            },
                                        ],
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                ],
                            },
                            {
                                id: 'payloadConfig',
                                displayName: 'Payload',
                                array: false,
                                canAddRecord: false,
                                active: false,
                                isFieldInConfiguredData: false,
                                canDeleteRecord: false,
                                noSubObjectForFields: true,
                                structure: 'FORM',
                                fields: [
                                    {
                                        id: 'payloadType',
                                        displayName: 'Payload Type',
                                        required: true,
                                        type: 'OPTIONS',
                                        isFieldInConfiguredData: true,
                                        options: [],
                                        defaultValue: 'RAW_BODY',
                                        hideSelectIfValueExists: true,
                                        supportOptionsConfigProperty: 'payloadTypes',
                                    },
                                    {
                                        id: 'formKey',
                                        displayName: 'Form Key',
                                        required: true,
                                        type: 'TEXT',
                                        isFieldInConfiguredData: true,
                                        options: [],
                                        controlledBy: 'payloadType',
                                    },
                                    {
                                        id: 'formDataType',
                                        displayName: 'Form Data Type',
                                        required: true,
                                        type: 'OPTIONS',
                                        isFieldInConfiguredData: true,
                                        options: [],
                                        supportOptionsConfigProperty: 'formDataTypes',
                                        controlledBy: 'payloadType',
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
        fieldsToRemoveFromResponse: ['config.integrationSettings', 'config.method'],
    };

    reportOutboundIntegrations: IntegrationModal = {
        api: 'outbound',
        canAddRecord: false,
        canTestConnection: true,
        canUpdateRecord: true,
        useMaster: false,
        displayName: 'Outbound Integration',
        tableFieldIds: undefined,
        tableRecordActions: undefined,
        fields: [
            {
                array: false,
                conditionalDisplay: false,
                conditionalDisable: [
                    {
                        type: 'ALL_MUST_SATISFY',
                        conditions: [
                            {
                                fieldId: 'id',
                                valueExists: true,
                            },
                            {
                                fieldId: 'type',
                                valueExists: true,
                            },
                        ],
                    },
                ],
                displayName: 'Integration Method',
                id: 'type',
                required: true,
                type: 'API_CONFIG',
                errors: [],
                hideLabel: false,
                inputTypeConditonal: false,
                options: (() => {
                    const allOptions = [
                        {
                            id: 'ftp',
                            displayName: translate('FTP') as string,
                            value: 'FTP',
                        },

                        {
                            id: 's3',
                            displayName: translate('S3') as string,
                            value: 'S3',
                        },
                        {
                            id: 'restapi',
                            displayName: translate('RESTAPI') as string,
                            value: 'RESTAPI',
                        },
                        {
                            id: 'sahrepoint',
                            displayName: translate('SHAREPOINT') as string,
                            value: 'SHAREPOINT',
                        },
                    ];
                    return allOptions.filter(item => this.integrationRestriction.indexOf(item.id.toLowerCase()) === -1);
                })(),
                idFieldInSubObjectOnly: false,
                isFieldInMainData: true,
                subFieldObject: 'type',
                fieldIdInMainData: 'integrationMethod',
            },
            {
                id: 'configId',
                displayName: 'Configured List',
                required: true,
                conditionalDisplay: [
                    {
                        type: 'ALL_MUST_SATISFY',
                        conditions: [
                            {
                                fieldId: 'type',
                                valueExists: true,
                            },
                        ],
                    },
                ],
                type: 'API_CONFIGURED_LIST',
                options: [],
                defaultValue: undefined,
                subFieldObject: 'type',
                idFieldInSubObjectOnly: true,
            },
            {
                id: 'relativePath',
                displayName: 'Relative Folder Path',
                required: true,
                conditionalDisplay: [
                    {
                        type: 'ANY_SATISFY',
                        conditions: [
                            {
                                fieldId: 'type',
                                requiredValue: 'FTP',
                            },
                            {
                                fieldId: 'type',
                                requiredValue: 'S3',
                            },
                        ],
                    },
                ],
                inputTypeConditonal: true,
                type: 'TEXT',
                options: [],
                defaultValue: undefined,
                subFieldObject: 'type',
                idFieldInSubObjectOnly: true,
            },
            {
                id: 'folderPath',
                displayName: 'Folder Path',
                required: true,
                conditionalDisplay: [
                    {
                        type: 'ANY_SATISFY',
                        conditions: [
                            {
                                fieldId: 'type',
                                requiredValue: 'SHAREPOINT',
                            },
                        ],
                    },
                ],
                inputTypeConditonal: true,
                type: 'TEXT',
                options: [],
                subFieldObject: 'type',
                idFieldInSubObjectOnly: true,
                defaultValue: '/',
                hint: 'Example: /Documents/Invoices/2026/',
            },
            {
                displayName: 'Active',
                id: 'active',
                subFieldObject: 'type',
                array: false,
                defaultValue: false,
                conditionalDisplay: [
                    {
                        type: 'ANY_SATISFY',
                        conditions: [
                            {
                                fieldId: 'type',
                                requiredValue: 'FTP',
                            },
                            {
                                fieldId: 'type',
                                requiredValue: 'S3',
                            },
                            {
                                fieldId: 'type',
                                requiredValue: 'SHAREPOINT',
                            },
                        ],
                    },
                ],
                type: 'INPUT_RADIO',
                options: [
                    {
                        displayName: 'Yes',
                        id: 'yes',
                        value: true,
                    },
                    {
                        displayName: 'No',
                        id: 'no',
                        value: false,
                    },
                ],
                errors: [],
                hideLabel: false,
                hint: undefined,
                inputTypeConditonal: true,
                required: true,
                idFieldInSubObjectOnly: true,
            },
            {
                array: false,
                conditionalDisable: false,
                conditionalDisplay: false,
                defaultValue: true,
                displayName: 'Trigger Job',
                errors: [],
                id: 'triggerJob',
                show: false,
                type: 'TEXT',
                required: false,
                subFieldObject: 'type',
                idFieldInSubObjectOnly: true,
            },
            {
                array: false,
                conditionalDisable: false,
                conditionalDisplay: false,
                defaultValue: false,
                displayName: 'Use Common Folder',
                errors: [],
                id: 'useCommonFolder',
                show: false,
                type: 'INPUT_RADIO',
                required: false,
                subFieldObject: 'type',
                idFieldInSubObjectOnly: true,
            },
            {
                array: false,
                conditionalDisable: false,
                conditionalDisplay: false,
                defaultValue: 'FILE',
                displayName: 'Use Common Folder',
                errors: [],
                id: 'componentType',
                show: false,
                type: 'TEXT',
                required: false,
                subFieldObject: 'type',
                idFieldInSubObjectOnly: true,
            },
        ],
    };

    inboundMasters: IntegrationModal = {
        api: 'masterinbound',
        canAddRecord: false,
        canTestConnection: true,
        canUpdateRecord: true,
        useMaster: false,
        displayName: 'Inbound Integration',
        tableFieldIds: [
            'configName',
            'chainName',
            'transformationName',
            'createdByUserName',
            'createdDate',
            'modifiedByUserName',
            'lastModifiedDate',
        ],
        tableRecordActions: undefined,
        fields: [
            {
                array: false,
                displayName: 'Configuration Name',
                defaultValue: 'DefaultConfiguration',
                errors: [],
                id: 'configName',
                conditionalDisable: [
                    {
                        type: 'ANY_SATISFY',
                        conditions: [
                            {
                                fieldId: 'locationId',
                                valueExists: true,
                            },
                        ],
                    },
                ],
                options: [],
                required: true,
                type: 'TEXT',
                isFieldInMainDataOnly: true,
            },
            {
                array: false,
                displayName: 'Chain',
                errors: [],
                id: 'chainName',
                options: [],
                required: true,
                type: 'CHAIN_DROPDOWN',
                isFieldInMainDataOnly: true,
                conditionalDisable: [
                    {
                        type: 'ALL_MUST_SATISFY',
                        conditions: [
                            {
                                fieldId: 'locationId',
                                valueExists: true,
                            },
                            {
                                fieldId: 'chainName',
                                valueExists: true,
                            },
                        ],
                    },
                ],
            },
            {
                array: false,
                displayName: 'Transformation',
                errors: [],
                id: 'transformationName',
                options: [],
                required: true,
                type: 'TRANSFORMATIONS_DROPDOWN',
                isFieldInMainDataOnly: true,
                conditionalDisable: [
                    {
                        type: 'ANY_SATISFY',
                        conditions: [
                            {
                                fieldId: 'locationId',
                                valueExists: true,
                            },
                        ],
                    },
                ],
            },
            {
                id: 'createdByUserName',
                displayName: 'Created By',
                required: false,
                type: 'TEXT',
                show: false,
                copyToPayload: false,
            },
            {
                id: 'createdDate',
                displayName: 'Created Date',
                required: false,
                type: 'TEXT',
                show: false,
                decodingType: 'DATE',
                copyToPayload: false,
            },
            {
                id: 'modifiedByUserName',
                displayName: 'Modified By',
                required: false,
                type: 'TEXT',
                show: false,
                copyToPayload: false,
            },
            {
                id: 'lastModifiedDate',
                displayName: 'Modified Date',
                required: false,
                type: 'TEXT',
                show: false,
                decodingType: 'DATE',
                copyToPayload: false,
            },
        ],
        subSections: [
            {
                displayName: 'Integration Methods for Sources',
                id: 'configs',
                structure: 'RECORDS_FORM',
                canAddRecord: true,
                canDeleteRecord: true,
                array: true,
                haveTabs: false,
                fields: [
                    {
                        array: false,
                        displayName: 'Source Name',
                        errors: [],
                        id: 'resourceName',
                        options: [],
                        uniqueValueInRecords: true,
                        required: true,
                        type: 'SOURCES_DROPDOWN',
                    },
                    {
                        array: false,
                        displayName: 'Integration Method',
                        errors: [],
                        id: 'integrationMethod',
                        options: (() => {
                            const allOptions = [
                                {
                                    id: 'ftp',
                                    displayName: translate('FTP') as string,
                                    value: 'FTP',
                                },

                                {
                                    id: 's3',
                                    displayName: translate('S3') as string,
                                    value: 'S3',
                                },
                                {
                                    id: 'restapi',
                                    displayName: translate('RESTAPI') as string,
                                    value: 'RESTAPI',
                                },
                                {
                                    id: 'sharepoint',
                                    displayName: translate('SHAREPOINT') as string,
                                    value: 'SHAREPOINT',
                                },
                            ];
                            return allOptions.filter(item => this.integrationRestriction.indexOf(item.id.toLowerCase()) === -1);
                        })(),
                        required: true,
                        type: 'API_CONFIG',
                    },
                    {
                        array: false,
                        displayName: 'Configuration',
                        errors: [],
                        id: 'globalConfigName',
                        options: [],
                        required: true,
                        type: 'API_CONFIGURED_LIST',
                        isFieldInConfiguredData: true,
                    },
                    {
                        array: false,
                        displayName: 'Organization Id',
                        errors: [],
                        id: 'orgId',
                        options: [],
                        required: false,
                        show: false,
                        type: 'TEXT',
                        isFieldInConfiguredData: true,
                    },
                    {
                        array: false,
                        displayName: 'Relative Folder Path',
                        errors: [],
                        id: 'relativePath',
                        options: [],
                        uniqueValueInRecords: true,
                        required: true,
                        type: 'TEXT',
                        isFieldInConfiguredData: true,
                        conditionalDisplay: [
                            {
                                type: 'ANY_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'FTP',
                                    },
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'S3',
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        array: false,
                        displayName: 'Folder Path',
                        errors: [],
                        id: 'folderPath',
                        options: [],
                        uniqueValueInRecords: true,
                        required: true,
                        type: 'TEXT',
                        isFieldInConfiguredData: true,
                        conditionalDisplay: [
                            {
                                type: 'ANY_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'SHAREPOINT',
                                    },
                                ],
                            },
                        ],
                        defaultValue: '/',
                        hint: 'Example: /Documents/Invoices/2026/',
                    },
                    {
                        id: 'fileNamePattern',
                        displayName: 'File Name Pattern',
                        required: false,
                        errors: [],
                        isFieldInConfiguredData: true,
                        conditionalDisplay: [
                            {
                                type: 'ANY_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'FTP',
                                    },
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'S3',
                                    },
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'SHAREPOINT',
                                    },
                                ],
                            },
                        ],
                        type: 'TEXT',
                        defaultValue: undefined,
                    },
                    {
                        array: false,
                        displayName: 'Checksum Verification',
                        id: 'checksumVerification',
                        required: false,
                        isFieldInConfiguredData: true,
                        conditionalDisplay: [
                            {
                                type: 'ANY_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'FTP',
                                    },
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'S3',
                                    },
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'SHAREPOINT',
                                    },
                                ],
                            },
                        ],
                        type: 'OPTIONS',
                        options: [
                            {
                                id: 'marker',
                                displayName: 'Marker',
                                value: 'marker',
                            },
                            {
                                id: 'checksumFile',
                                displayName: 'Checksum File',
                                value: 'checksumFile',
                            },
                        ],
                        errors: [],
                    },
                    {
                        array: false,
                        displayName: 'File Extension',
                        id: 'checksumFileExtension',
                        required: true,
                        conditionalDisplay: [
                            {
                                type: 'ANY_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'checksumVerification',
                                        requiredValue: 'marker',
                                    },
                                    {
                                        fieldId: 'checksumVerification',
                                        requiredValue: 'checksumFile',
                                    },
                                ],
                            },
                        ],
                        type: 'TEXT',
                        errors: [],
                        isFieldInConfiguredData: true,
                    },
                ],
                hasChildSubSectons: true,
                childSubSections: [
                    {
                        structure: 'HTTP',
                        haveTabs: false,
                        array: false,
                        conditionalDisplay: [
                            {
                                type: 'ANY_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'RESTAPI',
                                    },
                                ],
                            },
                        ],
                        fields: [
                            {
                                id: 'method',
                                displayName: 'Method',
                                errors: [],
                                required: true,
                                type: 'OPTIONS',
                                options: [
                                    {
                                        id: 'get',
                                        displayName: this.translator('Get'),
                                        value: 'GET',
                                    },
                                    {
                                        id: 'post',
                                        displayName: this.translator('Post'),
                                        value: 'POST',
                                    },
                                    {
                                        id: 'put',
                                        displayName: this.translator('Put'),
                                        value: 'PUT',
                                    },
                                ],
                                isFieldInConfiguredData: true,
                                uiType: 'HTTP-method',
                                defaultValue: 'GET',
                                tailwindClasses: ['rounded-r-none'],
                                hideHintElements: true,
                                appearance: 'outline',
                            },
                            {
                                id: 'url',
                                displayName: 'Relative Url',
                                required: false,
                                type: 'TEXT',
                                defaultValue: undefined,
                                errors: [],
                                isFieldInConfiguredData: true,
                                uiType: 'HTTP-url',
                                hideHintElements: true,
                                appearance: 'outline',
                                tailwindClasses: ['rounded-l-none', 'border-l-0'],
                            },
                        ],
                    },
                    {
                        structure: 'POSTMAN_NEW',
                        haveTabs: true,
                        conditionalDisplay: [
                            {
                                type: 'ALL_MUST_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'RESTAPI',
                                    },
                                ],
                            },
                        ],
                        tabs: [
                            {
                                id: 'headers',
                                displayName: 'Header',
                                array: true,
                                canAddRecord: true,
                                active: true,
                                isFieldInConfiguredData: true,
                                canDeleteRecord: true,
                                structure: 'TABLE',
                                fields: [
                                    {
                                        id: 'key',
                                        displayName: 'Key',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'TEXT',
                                        required: false,
                                        isUnique: true,
                                        position: 'COLUMN',
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'values',
                                        displayName: 'Value',
                                        valueAsArrayInPayload: true,
                                        conditionalDisplay: false,
                                        inputTypeConditonal: true,
                                        type: 'TEXT',
                                        required: false,
                                        position: 'COLUMN',
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                ],
                                recordActions: [],
                            },
                            {
                                id: 'body',
                                displayName: 'Body',
                                array: false,
                                canAddRecord: false,
                                active: false,
                                isFieldInConfiguredData: true,
                                canDeleteRecord: false,
                                noSubObjectForFields: true,
                                fields: [
                                    {
                                        id: 'type',
                                        displayName: 'Body Type',
                                        required: false,
                                        show: false,
                                        copyToPayload: true,
                                        conditionalDisplay: false,
                                        options: [
                                            {
                                                id: 'text',
                                                displayName: 'TEXT',
                                                value: 'Text',
                                            },
                                            {
                                                id: 'json',
                                                displayName: 'JSON',
                                                value: 'JSON',
                                            },
                                            {
                                                id: 'xml',
                                                displayName: 'XML',
                                                value: 'XML',
                                            },
                                        ],
                                        tailwindClasses: ['border-0', 'py-0', 'w-[auto]', 'text-taxillaGreen'],
                                        hideHintElements: true,
                                        type: 'BODY_TYPE',
                                    },
                                    {
                                        id: 'content',
                                        displayName: 'Raw Text',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'BODY_EDITOR',
                                        required: false,
                                    },
                                    {
                                        id: 'language',
                                        displayName: 'Language',
                                        show: false,
                                        copyToPayload: false,
                                        conditionalDisplay: false,
                                        type: 'INPUT_RADIO',
                                        defaultValueIf: [
                                            {
                                                type: 'ALL_MUST_SATISFY',
                                                defaultValue: 'raw',
                                                conditions: [
                                                    {
                                                        fieldId: 'content',
                                                        valueExists: true,
                                                    },
                                                ],
                                            },
                                            {
                                                type: 'ALL_MUST_SATISFY',
                                                defaultValue: 'graphql',
                                                conditions: [
                                                    {
                                                        fieldId: 'query',
                                                        valueExists: true,
                                                    },
                                                    {
                                                        fieldId: 'variables',
                                                        valueExists: true,
                                                    },
                                                ],
                                            },
                                            {
                                                type: 'ALL_MUST_SATISFY',
                                                defaultValue: 'jsonrpc',
                                                conditions: [
                                                    {
                                                        fieldId: 'jsonRpcMethod',
                                                        valueExists: true,
                                                    },
                                                    {
                                                        fieldId: 'jsonRpcParams',
                                                        valueExists: true,
                                                    },
                                                ],
                                            },
                                            {
                                                type: 'ALL_MUST_SATISFY',
                                                defaultValue: 'formUrlEncodedParams',
                                                conditions: [
                                                    {
                                                        fieldId: 'formUrlEncodedParams',
                                                        valueExists: true,
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        id: 'query',
                                        displayName: 'Query',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'QUERY_EDITOR',
                                        required: false,
                                        show: false,
                                        copyToPayload: true,
                                    },
                                    {
                                        id: 'variables',
                                        displayName: 'Variables',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'VARIABLES_EDITOR',
                                        required: false,
                                        show: false,
                                        copyToPayload: true,
                                        encodingType: 'JSON',
                                        decodingType: 'STRING',
                                    },
                                    {
                                        id: 'jsonRpcMethod',
                                        displayName: 'Json Rpc Method',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'JSON_RPC_METHOD',
                                        required: false,
                                        show: false,
                                        copyToPayload: true,
                                    },
                                    {
                                        id: 'jsonRpcParams',
                                        displayName: 'Json Rpc Params',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'JSON_RPC_PARAMS',
                                        required: false,
                                        show: false,
                                        copyToPayload: true,
                                        encodingType: 'JSON',
                                        decodingType: 'STRING',
                                    },
                                ],
                                conditionallyDisable: true,
                                disableConditions: [
                                    {
                                        type: 'ANY_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'method',
                                                requiredValue: 'GET',
                                            },
                                        ],
                                    },
                                ],
                                childSubSections: [
                                    {
                                        id: 'formUrlEncodedParams',
                                        structure: 'TABLE',
                                        array: true,
                                        isObject: true,
                                        keyFieldId: 'key',
                                        valueFieldId: 'value',
                                        haveTabs: false,
                                        conditionalDisplay: [
                                            {
                                                type: 'ANY_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'language',
                                                        requiredValue: 'formUrlEncodedParams',
                                                    },
                                                ],
                                            },
                                        ],
                                        fields: [
                                            {
                                                id: 'key',
                                                displayName: 'Key',
                                                conditionalDisplay: false,
                                                inputTypeConditonal: false,
                                                type: 'TEXT',
                                                required: false,
                                                show: true,
                                                isUnique: true,
                                                copyToPayload: true,
                                                position: 'COLUMN',
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0'],
                                            },
                                            {
                                                id: 'value',
                                                displayName: 'Value',
                                                conditionalDisplay: false,
                                                inputTypeConditonal: true,
                                                type: 'TEXT',
                                                required: false,
                                                show: true,
                                                copyToPayload: true,
                                                position: 'COLUMN',
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0'],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                id: 'queryParams',
                                displayName: 'Query Params',
                                array: true,
                                isFieldInConfiguredData: true,
                                canAddRecord: true,
                                canDeleteRecord: true,
                                structure: 'TABLE',
                                fields: [
                                    {
                                        id: 'key',
                                        displayName: 'Key',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'TEXT',
                                        required: false,
                                        isUnique: true,
                                        position: 'COLUMN',
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'values',
                                        displayName: 'Value',
                                        valueAsArrayInPayload: true,
                                        conditionalDisplay: false,
                                        inputTypeConditonal: true,
                                        type: [
                                            {
                                                fieldId: 'dynamicExp',
                                                requiredValue: true,
                                                type: 'OPTIONS',
                                            },
                                            {
                                                fieldId: 'dynamicExp',
                                                requiredValue: false,
                                                type: 'TEXT',
                                            },
                                        ],
                                        required: false,
                                        position: 'COLUMN',
                                        options: [
                                            {
                                                displayName: 'Current Month',
                                                id: 'currentMonth',
                                                value: 'm',
                                            },
                                            {
                                                displayName: 'Current Year',
                                                id: 'currentYear',
                                                value: 'y',
                                            },
                                            {
                                                displayName: 'Current Date',
                                                id: 'currentDate',
                                                value: 'd',
                                            },
                                            {
                                                displayName: 'Beginning of Month',
                                                id: 'beginningOfMonth',
                                                value: 'bom',
                                            },
                                            {
                                                displayName: 'End of Month',
                                                id: 'endOfMonth',
                                                value: 'eom',
                                            },
                                            {
                                                displayName: 'Scheduler from Date',
                                                id: 'schedulerFromDate',
                                                value: 'schedular_from_date',
                                            },
                                            {
                                                displayName: 'Scheduler to Date',
                                                id: 'schedulerToDate',
                                                value: 'schedular_to_date',
                                            },
                                            {
                                                displayName: 'Other',
                                                id: 'other',
                                                value: 'other',
                                            },
                                        ],
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                ],
                                recordActions: [],
                            },
                            {
                                id: 'placeHolderMappings',
                                displayName: 'PlaceHolder Mappings',
                                array: true,
                                isObject: true,
                                keyFieldId: 'key',
                                active: false,
                                isFieldInConfiguredData: false,
                                placHolderMapping: true,
                                structure: 'TABLE',
                                fields: [
                                    {
                                        id: 'key',
                                        displayName: 'Key',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'TEXT',
                                        required: false,
                                        position: 'COLUMN',
                                        isUnique: true,
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'autoGenerate',
                                        displayName: 'Auto Generate',
                                        required: true,
                                        array: false,
                                        conditionalDisable: [
                                            {
                                                type: 'ANY_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'key',
                                                        valueExists: false,
                                                    },
                                                ],
                                            },
                                        ],
                                        isMasterField: true,
                                        defaultValue: false,
                                        position: 'COLUMN',
                                        placeHolderMapping: true,
                                        isFieldInConfiguredData: false,
                                        type: 'CHECKBOX',
                                        hideLabel: true,
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'dynamicParamsKey',
                                        displayName: 'Dynamic Params Key',
                                        required: false,
                                        type: 'DYNAMIC_PARAMS_DROPDOWN',
                                        isFieldInConfiguredData: false,
                                        options: [],
                                        validations: ['checkValueExists'],
                                        errors: [],
                                        array: false,
                                        position: 'COLUMN',
                                        placeHolderMapping: true,
                                        conditionalDisable: [
                                            {
                                                type: 'ANY_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'key',
                                                        valueExists: false,
                                                    },
                                                    {
                                                        fieldId: 'autoGenerate',
                                                        requiredValue: false,
                                                    },
                                                ],
                                            },
                                        ],
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                        supportOptionsConfigProperty: 'dynamicParamsKeys',
                                    },
                                    {
                                        id: 'fieldType',
                                        displayName: 'Field Type',
                                        required: false,
                                        type: 'TEXT',
                                        isFieldInConfiguredData: false,
                                        options: [],
                                        validations: ['checkValueExists'],
                                        errors: [],
                                        array: false,
                                        position: 'COLUMN',
                                        placeHolderMapping: true,
                                        disabled: true,
                                        copyToPayload: false,
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'dateFormat',
                                        displayName: 'Date Format',
                                        required: false,
                                        type: 'TEXT',
                                        defaultValue: 'DD-MM-YYYY',
                                        errors: [],
                                        isFieldInConfiguredData: false,
                                        placeHolderMapping: true,
                                        position: 'COLUMN',
                                        conditionalDisable: [
                                            {
                                                type: 'ANY_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'key',
                                                        valueExists: false,
                                                    },
                                                    {
                                                        fieldId: 'autoGenerate',
                                                        requiredValue: false,
                                                    },
                                                    {
                                                        fieldId: 'fieldType',
                                                        requiredValue: 'SYSTEM',
                                                    },
                                                ],
                                            },
                                        ],
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'replacementPlaceHolderKey',
                                        displayName: 'Replacement Key',
                                        required: false,
                                        defaultValue: undefined,
                                        errors: [],
                                        isFieldInConfiguredData: false,
                                        position: 'COLUMN',
                                        placeHolderMapping: true,
                                        conditionalDisable: [
                                            {
                                                type: 'ANY_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'key',
                                                        valueExists: false,
                                                    },
                                                    {
                                                        fieldId: 'autoGenerate',
                                                        requiredValue: true,
                                                    },
                                                ],
                                            },
                                        ],
                                        type: 'TEXT',
                                        hideLabel: true,
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'additionalFieldRequired',
                                        displayName: 'Additional Field Required',
                                        show: true,
                                        required: false,
                                        position: 'COLUMN',
                                        type: 'CHECKBOX',
                                        hideLabel: true,
                                        placeHolderMapping: true,
                                        disabled: true,
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'offsetValue',
                                        displayName: 'Offset Value',
                                        required: false,
                                        type: 'TEXT',
                                        isFieldInConfiguredData: false,
                                        options: [],
                                        validations: ['checkValueExists'],
                                        errors: [],
                                        array: false,
                                        position: 'COLUMN',
                                        placeHolderMapping: true,
                                        conditionalDisable: [
                                            {
                                                type: 'ANY_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'key',
                                                        valueExists: false,
                                                    },
                                                    {
                                                        fieldId: 'additionalFieldRequired',
                                                        requiredValue: false,
                                                    },
                                                    {
                                                        fieldId: 'additionalFieldRequired',
                                                        requiredValue: undefined,
                                                    },
                                                ],
                                            },
                                        ],
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                displayName: 'Scheduler Details',
                structure: 'FORM',
                haveTabs: false,
                fields: [
                    {
                        displayName: 'Trigger Job',
                        id: 'triggerJob',
                        array: false,
                        defaultValue: false,
                        required: true,
                        type: 'INPUT_RADIO',
                        options: [
                            {
                                id: 'yes',
                                displayName: 'Yes',
                                value: true,
                            },
                            {
                                id: 'no',
                                displayName: 'No',
                                value: false,
                            },
                        ],
                        errors: [],
                        hideLabel: false,
                        inputTypeConditonal: true,
                    },
                ],
            },
            {
                structure: 'FLEX_FORM',
                id: 'schedulerExpression',
                appendType: 'cronExpression',
                haveTabs: false,
                conditionalDisplay: [
                    {
                        type: 'ALL_MUST_SATISFY',
                        conditions: [
                            {
                                fieldId: 'triggerJob',
                                requiredValue: true,
                            },
                        ],
                    },
                ],
                fields: [
                    {
                        displayName: 'Cron Expression',
                        id: 'schedulerExpression',
                        array: false,
                        defaultValue: '0 10 1 1 ?',
                        required: true,
                        type: 'TEXT',
                        errors: [],
                        hideLabel: false,
                        inputTypeConditonal: true,
                    },
                ],
            },
        ],
    };

    connectors: IntegrationModal = {
        api: 'connectors',
        canAddRecord: false,
        canTestConnection: true,
        useMaster: false,
        canUpdateRecord: true,
        displayName: 'Connectors',
        tableRecordActions: undefined,
        fields: [
            {
                array: false,
                displayName: 'Connectors Name',
                defaultValue: '',
                errors: [],
                id: 'connectorName',
                options: [],
                required: true,
                type: 'TEXT',
                isFieldInMainDataOnly: true,
            },
            {
                array: false,
                displayName: 'Connectors DisplayName',
                defaultValue: '',
                errors: [],
                id: 'connectorDisplayName',
                options: [],
                required: true,
                type: 'TEXT',
                isFieldInMainDataOnly: true,
            },
            {
                array: false,
                displayName: 'Description',
                defaultValue: '',
                errors: [],
                id: 'description',
                options: [],
                required: true,
                type: 'TEXTAREA',
                isFieldInMainDataOnly: true,
            },
        ],
        subSections: [
            {
                id: 'sourceSystem',
                displayName: 'Source System',
                structure: 'FORM',
                haveTabs: false,
                fields: [
                    {
                        id: 'sourceSystem',
                        displayName: 'Source System',
                        required: true,
                        inputTypeConditonal: false,
                        type: 'OPTIONS',
                        options: [],
                        conditionalDisplay: false,
                        supportOptionsConfigProperty: 'connectorSourceSystems',
                        optionActionsProperty: [{ name: 'Edit', icon: 'edit' }],
                    },
                ],
            },
            {
                displayName: 'API List',
                subDisplayName: 'Basic Info',
                id: 'connectorApis',
                structure: 'RECORDS_FORM',
                canAddRecord: true,
                canDeleteRecord: true,
                array: true,
                useAccordion: true,
                accordionHeaderFieldId: 'apiName',
                haveTabs: false,
                styles: {
                    fieldsContainer: ['border', 'border-gray-200', 'px-6', 'my-2', 'rounded'],
                    subDisplayName: ['flex', 'items-center', 'justify-between', 'w-full', '!mt-0', '!mb-[30px]'],
                },
                fields: [
                    {
                        id: 'apiName',
                        displayName: 'API Name',
                        required: true,
                        type: 'TEXT',
                        defaultValue: undefined,
                        errors: [],
                        isFieldInConfiguredData: false,
                    },
                    {
                        id: 'apiOrder',
                        displayName: 'API Order',
                        required: true,
                        type: 'TEXT',
                        defaultValue: undefined,
                        errors: [],
                        validations: ['checkInteger'],
                        isFieldInConfiguredData: false,
                        hasEncoding: true,
                        encodingType: 'NUMBER',
                    },
                    {
                        id: 'chainConnectorsExists',
                        displayName: 'Has Chain Connectors',
                        required: true,
                        array: false,
                        defaultValue: true,
                        copyToPayload: false,
                        type: 'INPUT_RADIO',
                        placeHolderMapping: true,
                        options: [
                            {
                                id: 'yes',
                                displayName: 'Yes',
                                value: true,
                            },
                            {
                                id: 'no',
                                displayName: 'No',
                                value: false,
                            },
                        ],
                        defaultValueIf: [
                            {
                                type: 'ALL_MUST_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'chainConnectors',
                                        valueExists: true,
                                    },
                                ],
                            },
                        ],
                    },
                ],
                hasChildSubSectons: true,
                childSubSections: [
                    {
                        displayName: 'Source',
                        structure: 'HTTP',
                        haveTabs: false,
                        array: false,
                        styles: {
                            container: ['border', 'border-gray-200', 'px-6', 'my-6', 'rounded'],
                            displayName: ['flex', 'items-center', 'justify-between', 'w-full', '!mt-0', '!mb-[30px]'],
                        },
                        conditionalDisplay: [
                            {
                                type: 'ALL_MUST_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'chainConnectorsExists',
                                        requiredValue: false,
                                    },
                                ],
                            },
                        ],
                        fields: [
                            {
                                id: 'httpMethod',
                                displayName: 'HTTP Method',
                                errors: [],
                                required: true,
                                type: 'OPTIONS',
                                uiType: 'HTTP-method',
                                defaultValue: 'GET',
                                tailwindClasses: ['rounded-r-none'],
                                hideHintElements: true,
                                appearance: 'outline',
                                options: [
                                    {
                                        id: 'get',
                                        value: 'GET',
                                        displayName: this.translator('Get'),
                                    },
                                    {
                                        id: 'post',
                                        displayName: this.translator('Post'),
                                        value: 'POST',
                                    },
                                    {
                                        id: 'put',
                                        displayName: this.translator('Put'),
                                        value: 'PUT',
                                    },
                                ],
                                isFieldInConfiguredData: false,
                            },
                            {
                                id: 'apiEndpoint',
                                displayName: 'Enter URL',
                                required: true,
                                type: 'TEXT',
                                defaultValue: undefined,
                                errors: [],
                                isFieldInConfiguredData: false,
                                uiType: 'HTTP-url',
                                hideHintElements: true,
                                appearance: 'outline',
                                tailwindClasses: ['rounded-l-none', 'border-l-0'],
                            },
                        ],
                        hasChildSubSectons: true,
                        childSubSections: [
                            {
                                structure: 'POSTMAN_NEW',
                                haveTabs: true,
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'chainConnectorsExists',
                                                requiredValue: false,
                                            },
                                        ],
                                    },
                                ],
                                tabs: [
                                    {
                                        id: 'authorization',
                                        displayName: 'Authorization',
                                        array: false,
                                        canAddRecord: false,
                                        isObject: false,
                                        isFieldInConfiguredData: false,
                                        structure: 'FORM',
                                        copyToPayload: false,
                                        fields: [
                                            {
                                                id: 'authorization',
                                                displayName: 'Authorization',
                                                disabled: true,
                                                copyToPayload: false,
                                                type: 'TEXT',
                                                required: false,
                                                referenceFieldId: 'sourceSystem',
                                            },
                                        ],
                                        recordActions: [],
                                    },
                                    {
                                        id: 'headers',
                                        displayName: 'Header',
                                        array: true,
                                        canAddRecord: true,
                                        active: true,
                                        isObject: true,
                                        keyFieldId: 'key',
                                        valueFieldId: 'values',
                                        isFieldInConfiguredData: false,
                                        canDeleteRecord: true,
                                        structure: 'TABLE',
                                        fields: [
                                            {
                                                id: 'key',
                                                displayName: 'Key',
                                                conditionalDisplay: false,
                                                inputTypeConditonal: false,
                                                type: 'TEXT',
                                                required: false,
                                                isUnique: true,
                                                position: 'COLUMN',
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0'],
                                                hideHintElements: true,
                                            },
                                            {
                                                id: 'values',
                                                displayName: 'Value',
                                                valueAsArrayInPayload: false,
                                                conditionalDisplay: false,
                                                type: 'TEXT',
                                                required: true,
                                                validations: ['checkValueExists'],
                                                conditionalDisable: [
                                                    {
                                                        type: 'ANY_SATISFY',
                                                        conditions: [
                                                            {
                                                                fieldId: 'key',
                                                                valueExists: false,
                                                            },
                                                        ],
                                                    },
                                                ],
                                                position: 'COLUMN',
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0'],
                                                hideHintElements: true,
                                            },
                                        ],
                                        recordActions: [],
                                    },
                                    {
                                        displayName: 'Body',
                                        array: false,
                                        canAddRecord: false,
                                        active: false,
                                        isObject: false,
                                        isFieldInConfiguredData: false,
                                        canDeleteRecord: false,
                                        fields: [
                                            {
                                                id: 'language',
                                                displayName: 'Language',
                                                show: false,
                                                copyToPayload: false,
                                                conditionalDisplay: false,
                                                type: 'INPUT_RADIO',
                                                defaultValueIf: [
                                                    {
                                                        type: 'ALL_MUST_SATISFY',
                                                        defaultValue: 'raw',
                                                        conditions: [
                                                            {
                                                                fieldId: 'body',
                                                                valueExists: true,
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        type: 'ALL_MUST_SATISFY',
                                                        defaultValue: 'graphql',
                                                        conditions: [
                                                            {
                                                                fieldId: 'graphQlQuery',
                                                                valueExists: true,
                                                            },
                                                            {
                                                                fieldId: 'graphQlVariables',
                                                                valueExists: true,
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        type: 'ALL_MUST_SATISFY',
                                                        defaultValue: 'jsonrpc',
                                                        conditions: [
                                                            {
                                                                fieldId: 'jsonRpcMethod',
                                                                valueExists: true,
                                                            },
                                                            {
                                                                fieldId: 'jsonRpcParams',
                                                                valueExists: true,
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        type: 'ALL_MUST_SATISFY',
                                                        defaultValue: 'formUrlEncodedParams',
                                                        conditions: [
                                                            {
                                                                fieldId: 'formUrlEncodedParams',
                                                                valueExists: true,
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                id: 'body',
                                                displayName: 'Raw',
                                                conditionalDisplay: false,
                                                inputTypeConditonal: false,
                                                type: 'BODY_EDITOR',
                                                required: false,
                                            },
                                            {
                                                id: 'graphQlQuery',
                                                displayName: 'Query',
                                                conditionalDisplay: false,
                                                inputTypeConditonal: false,
                                                type: 'QUERY_EDITOR',
                                                required: false,
                                                show: false,
                                                copyToPayload: true,
                                            },
                                            {
                                                id: 'graphQlVariables',
                                                displayName: 'Variables',
                                                conditionalDisplay: false,
                                                inputTypeConditonal: false,
                                                type: 'VARIABLES_EDITOR',
                                                required: false,
                                                show: false,
                                                copyToPayload: true,
                                                encodingType: 'JSON',
                                                decodingType: 'STRING',
                                            },
                                            {
                                                id: 'jsonRpcMethod',
                                                displayName: 'Json Rpc Method',
                                                conditionalDisplay: false,
                                                inputTypeConditonal: false,
                                                type: 'JSON_RPC_METHOD',
                                                required: false,
                                                show: false,
                                                copyToPayload: true,
                                            },
                                            {
                                                id: 'jsonRpcParams',
                                                displayName: 'Json Rpc Params',
                                                conditionalDisplay: false,
                                                inputTypeConditonal: false,
                                                type: 'JSON_RPC_PARAMS',
                                                required: false,
                                                show: false,
                                                copyToPayload: true,
                                                encodingType: 'JSON',
                                                decodingType: 'STRING',
                                            },
                                        ],
                                        conditionallyDisable: true,
                                        disableConditions: [
                                            {
                                                type: 'ANY_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'httpMethod',
                                                        requiredValue: 'GET',
                                                    },
                                                ],
                                            },
                                        ],
                                        childSubSections: [
                                            {
                                                id: 'formUrlEncodedParams',
                                                structure: 'TABLE',
                                                array: true,
                                                isObject: true,
                                                keyFieldId: 'key',
                                                valueFieldId: 'value',
                                                haveTabs: false,
                                                conditionalDisplay: [
                                                    {
                                                        type: 'ANY_SATISFY',
                                                        conditions: [
                                                            {
                                                                fieldId: 'language',
                                                                requiredValue: 'formUrlEncodedParams',
                                                            },
                                                        ],
                                                    },
                                                ],
                                                fields: [
                                                    {
                                                        id: 'key',
                                                        displayName: 'Key',
                                                        conditionalDisplay: false,
                                                        inputTypeConditonal: false,
                                                        type: 'TEXT',
                                                        required: false,
                                                        show: true,
                                                        isUnique: true,
                                                        copyToPayload: true,
                                                        position: 'COLUMN',
                                                        appearance: 'outline',
                                                        tailwindClasses: ['border-0', 'py-0'],
                                                    },
                                                    {
                                                        id: 'value',
                                                        displayName: 'Value',
                                                        conditionalDisplay: false,
                                                        inputTypeConditonal: true,
                                                        type: 'TEXT',
                                                        required: false,
                                                        show: true,
                                                        copyToPayload: true,
                                                        position: 'COLUMN',
                                                        appearance: 'outline',
                                                        tailwindClasses: ['border-0', 'py-0'],
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        id: 'queryParams',
                                        displayName: 'Query Params',
                                        array: true,
                                        canAddRecord: true,
                                        active: false,
                                        isObject: true,
                                        keyFieldId: 'key',
                                        valueFieldId: 'values',
                                        isFieldInConfiguredData: false,
                                        canDeleteRecord: true,
                                        structure: 'TABLE',
                                        fields: [
                                            {
                                                id: 'key',
                                                displayName: 'Key',
                                                conditionalDisplay: false,
                                                inputTypeConditonal: false,
                                                type: 'TEXT',
                                                required: false,
                                                isUnique: true,
                                                position: 'COLUMN',
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0'],
                                                hideHintElements: true,
                                            },
                                            {
                                                id: 'values',
                                                displayName: 'Value',
                                                valueAsArrayInPayload: false,
                                                conditionalDisplay: false,
                                                type: 'TEXT',
                                                required: true,
                                                validations: ['checkValueExists'],
                                                conditionalDisable: [
                                                    {
                                                        type: 'ANY_SATISFY',
                                                        conditions: [
                                                            {
                                                                fieldId: 'key',
                                                                valueExists: false,
                                                            },
                                                        ],
                                                    },
                                                ],
                                                position: 'COLUMN',
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0'],
                                                hideHintElements: true,
                                            },
                                        ],
                                        recordActions: [],
                                    },
                                    {
                                        id: 'placeHolderMappings',
                                        displayName: 'PlaceHolder Mappings',
                                        array: true,
                                        isObject: true,
                                        keyFieldId: 'key',
                                        active: false,
                                        isFieldInConfiguredData: false,
                                        placHolderMapping: true,
                                        structure: 'TABLE',
                                        fields: [
                                            {
                                                id: 'key',
                                                displayName: 'Key',
                                                conditionalDisplay: false,
                                                inputTypeConditonal: false,
                                                type: 'TEXT',
                                                required: false,
                                                position: 'COLUMN',
                                                isUnique: true,
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0', 'w-[100px]'],
                                                hideHintElements: true,
                                            },
                                            {
                                                id: 'autoGenerate',
                                                displayName: 'Auto Generate',
                                                required: false,
                                                array: false,
                                                conditionalDisable: [
                                                    {
                                                        type: 'ALL_MUST_SATISFY',
                                                        conditions: [
                                                            {
                                                                fieldId: 'key',
                                                                valueExists: false,
                                                            },
                                                        ],
                                                    },
                                                ],
                                                isMasterField: true,
                                                defaultValue: false,
                                                position: 'COLUMN',
                                                placeHolderMapping: true,
                                                isFieldInConfiguredData: false,
                                                type: 'CHECKBOX',
                                                hideLabel: true,
                                                tailwindClasses: [],
                                                hideHintElements: true,
                                            },
                                            {
                                                id: 'dynamicParamsKey',
                                                displayName: 'Dynamic Params Key',
                                                required: false,
                                                type: 'DYNAMIC_PARAMS_DROPDOWN',
                                                isFieldInConfiguredData: false,
                                                options: [],
                                                validations: ['checkValueExists'],
                                                errors: [],
                                                array: false,
                                                position: 'COLUMN',
                                                placeHolderMapping: true,
                                                conditionalDisable: [
                                                    {
                                                        type: 'ANY_SATISFY',
                                                        conditions: [
                                                            {
                                                                fieldId: 'key',
                                                                valueExists: false,
                                                            },
                                                            {
                                                                fieldId: 'autoGenerate',
                                                                requiredValue: false,
                                                            },
                                                        ],
                                                    },
                                                ],
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0', 'w-[100px]'],
                                                hideHintElements: true,
                                                supportOptionsConfigProperty: 'dynamicParamsKeys',
                                            },
                                            {
                                                id: 'fieldType',
                                                displayName: 'Field Type',
                                                required: false,
                                                type: 'TEXT',
                                                isFieldInConfiguredData: false,
                                                options: [],
                                                validations: ['checkValueExists'],
                                                errors: [],
                                                array: false,
                                                position: 'COLUMN',
                                                placeHolderMapping: true,
                                                disabled: true,
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0', 'w-[100px]'],
                                                hideHintElements: true,
                                            },
                                            {
                                                id: 'dateFormat',
                                                displayName: 'Date Format',
                                                required: false,
                                                type: 'TEXT',
                                                defaultValue: 'DD-MM-YYYY',
                                                errors: [],
                                                isFieldInConfiguredData: false,
                                                placeHolderMapping: true,
                                                position: 'COLUMN',
                                                conditionalDisable: [
                                                    {
                                                        type: 'ANY_SATISFY',
                                                        conditions: [
                                                            {
                                                                fieldId: 'key',
                                                                valueExists: false,
                                                            },
                                                            {
                                                                fieldId: 'autoGenerate',
                                                                requiredValue: false,
                                                            },
                                                            {
                                                                fieldId: 'fieldType',
                                                                requiredValue: 'SYSTEM',
                                                            },
                                                        ],
                                                    },
                                                ],
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0', 'w-[100px]'],
                                                hideHintElements: true,
                                            },
                                            {
                                                id: 'replacementPlaceHolderKey',
                                                displayName: 'Replacement Key',
                                                required: false,
                                                defaultValue: undefined,
                                                errors: [],
                                                isFieldInConfiguredData: false,
                                                position: 'COLUMN',
                                                placeHolderMapping: true,
                                                conditionalDisable: [
                                                    {
                                                        type: 'ANY_SATISFY',
                                                        conditions: [
                                                            {
                                                                fieldId: 'key',
                                                                valueExists: false,
                                                            },
                                                            {
                                                                fieldId: 'autoGenerate',
                                                                requiredValue: true,
                                                            },
                                                        ],
                                                    },
                                                ],
                                                type: 'TEXT',
                                                hideLabel: true,
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0', 'w-[100px]'],
                                                hideHintElements: true,
                                            },
                                            {
                                                id: 'additionalFieldRequired',
                                                displayName: 'Additional Field Required',
                                                show: true,
                                                required: false,
                                                position: 'COLUMN',
                                                type: 'CHECKBOX',
                                                hideLabel: true,
                                                placeHolderMapping: true,
                                                disabled: true,
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0'],
                                                hideHintElements: true,
                                            },
                                            {
                                                id: 'offsetValue',
                                                displayName: 'Offset Value',
                                                required: false,
                                                type: 'TEXT',
                                                isFieldInConfiguredData: false,
                                                options: [],
                                                validations: ['checkValueExists'],
                                                errors: [],
                                                array: false,
                                                position: 'COLUMN',
                                                placeHolderMapping: true,
                                                conditionalDisable: [
                                                    {
                                                        type: 'ANY_SATISFY',
                                                        conditions: [
                                                            {
                                                                fieldId: 'additionalFieldRequired',
                                                                requiredValue: false,
                                                            },
                                                            {
                                                                fieldId: 'additionalFieldRequired',
                                                                requiredValue: undefined,
                                                            },
                                                            {
                                                                fieldId: 'autoGenerate',
                                                                requiredValue: false,
                                                            },
                                                        ],
                                                    },
                                                ],
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0', 'w-[100px]'],
                                                hideHintElements: true,
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                haveTabs: false,
                                structure: 'RECORD_FORM',
                                array: false,
                                fields: [
                                    {
                                        id: 'responseType',
                                        displayName: 'Response Type',
                                        required: false,
                                        errors: [],
                                        isFieldInConfiguredData: false,
                                        type: 'OPTIONS',
                                        defaultValue: undefined,
                                        supportOptionsConfigProperty: 'restApiResponseType',
                                        options: [],
                                    },
                                    {
                                        id: 'urlKey',
                                        displayName: 'URL Key',
                                        required: true,
                                        errors: [],
                                        isFieldInConfiguredData: false,
                                        conditionalDisplay: [
                                            {
                                                type: 'ALL_MUST_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'responseType',
                                                        requiredValue: 'URL',
                                                    },
                                                ],
                                            },
                                        ],
                                        type: 'TEXT',
                                    },
                                    {
                                        id: 'paginationEnabled',
                                        displayName: 'Pagination Enabled',
                                        required: false,
                                        array: false,
                                        defaultValue: false,
                                        isFieldInConfiguredData: false,
                                        type: 'INPUT_RADIO',
                                        options: [
                                            {
                                                id: 'yes',
                                                displayName: 'Yes',
                                                value: true,
                                            },
                                            {
                                                id: 'no',
                                                displayName: 'No',
                                                value: false,
                                            },
                                        ],
                                    },
                                    {
                                        type: 'TEXTAREA',
                                        id: 'paginationSchema',
                                        displayName: 'Pagination Schema',
                                        required: false,
                                        isFieldInConfiguredData: false,
                                        conditionalDisplay: [
                                            {
                                                type: 'ALL_MUST_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'paginationEnabled',
                                                        requiredValue: true,
                                                    },
                                                ],
                                            },
                                        ],
                                        informationType: 'JSON',
                                        informationSnippetType: 'snippet',
                                        supportedInformationProperty: 'paginationSchema',
                                        rows: 6,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        id: 'chainConnectors',
                        conditionalDisplay: [
                            {
                                type: 'ALL_MUST_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'chainConnectorsExists',
                                        requiredValue: true,
                                    },
                                ],
                            },
                        ],
                        haveTabs: false,
                        structure: 'RECORDS_FORM',
                        array: true,
                        useAccordion: true,
                        accordionHeaderFieldId: 'apiName',
                        canAddRecord: true,
                        canDeleteRecord: true,
                        displayName: 'Chain Connectors',
                        fields: [
                            {
                                id: 'apiName',
                                displayName: 'API Name',
                                required: true,
                                type: 'TEXT',
                                defaultValue: undefined,
                                errors: [],
                                isFieldInConfiguredData: false,
                            },
                            {
                                id: 'apiOrder',
                                displayName: 'API Order',
                                required: true,
                                type: 'TEXT',
                                defaultValue: undefined,
                                errors: [],
                                validations: ['checkInteger'],
                                isFieldInConfiguredData: false,
                                hasEncoding: true,
                                encodingType: 'NUMBER',
                            },
                        ],
                        hasChildSubSectons: true,
                        childSubSections: [
                            {
                                structure: 'HTTP',
                                haveTabs: false,
                                array: false,
                                fields: [
                                    {
                                        id: 'httpMethod',
                                        displayName: 'HTTP Method',
                                        errors: [],
                                        required: true,
                                        type: 'OPTIONS',
                                        uiType: 'HTTP-method',
                                        defaultValue: 'GET',
                                        tailwindClasses: ['rounded-r-none'],
                                        hideHintElements: true,
                                        appearance: 'outline',
                                        options: [
                                            {
                                                id: 'get',
                                                value: 'GET',
                                                displayName: this.translator('Get'),
                                            },
                                            {
                                                id: 'post',
                                                displayName: this.translator('Post'),
                                                value: 'POST',
                                            },
                                            {
                                                id: 'put',
                                                displayName: this.translator('Put'),
                                                value: 'PUT',
                                            },
                                        ],
                                        isFieldInConfiguredData: false,
                                    },
                                    {
                                        id: 'apiEndpoint',
                                        displayName: 'Enter URL',
                                        required: true,
                                        type: 'TEXT',
                                        defaultValue: undefined,
                                        errors: [],
                                        isFieldInConfiguredData: false,
                                        uiType: 'HTTP-url',
                                        hideHintElements: true,
                                        appearance: 'outline',
                                        tailwindClasses: ['rounded-l-none', 'border-l-0'],
                                    },
                                ],
                            },
                            {
                                structure: 'POSTMAN_NEW',
                                haveTabs: true,
                                tabs: [
                                    {
                                        id: 'authorization',
                                        displayName: 'Authorization',
                                        array: false,
                                        canAddRecord: false,
                                        isObject: false,
                                        isFieldInConfiguredData: false,
                                        structure: 'FORM',
                                        copyToPayload: false,
                                        fields: [
                                            {
                                                id: 'authorization',
                                                displayName: 'Authorization',
                                                disabled: true,
                                                copyToPayload: false,
                                                type: 'TEXT',
                                                required: false,
                                                referenceFieldId: 'sourceSystem',
                                            },
                                        ],
                                        recordActions: [],
                                    },
                                    {
                                        id: 'headers',
                                        displayName: 'Header',
                                        array: true,
                                        canAddRecord: true,
                                        active: true,
                                        isObject: true,
                                        keyFieldId: 'key',
                                        valueFieldId: 'values',
                                        isFieldInConfiguredData: false,
                                        canDeleteRecord: true,
                                        structure: 'TABLE',
                                        fields: [
                                            {
                                                id: 'key',
                                                displayName: 'Key',
                                                conditionalDisplay: false,
                                                type: 'TEXT',
                                                required: false,
                                                isUnique: true,
                                                position: 'COLUMN',
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0'],
                                                hideHintElements: true,
                                            },
                                            {
                                                id: 'values',
                                                displayName: 'Value',
                                                valueAsArrayInPayload: false,
                                                conditionalDisplay: false,
                                                type: 'TEXT',
                                                required: true,
                                                position: 'COLUMN',
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0'],
                                                hideHintElements: true,
                                                conditionalDisable: [
                                                    {
                                                        type: 'ANY_SATISFY',
                                                        conditions: [
                                                            {
                                                                fieldId: 'key',
                                                                valueExists: false,
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        ],
                                        recordActions: [],
                                    },
                                    {
                                        displayName: 'Body',
                                        array: false,
                                        canAddRecord: false,
                                        active: false,
                                        isObject: false,
                                        isFieldInConfiguredData: false,
                                        canDeleteRecord: false,
                                        fields: [
                                            {
                                                id: 'body',
                                                displayName: 'Raw',
                                                conditionalDisplay: false,
                                                type: 'BODY_EDITOR',
                                                required: false,
                                            },
                                            {
                                                id: 'graphQlQuery',
                                                displayName: 'Query',
                                                conditionalDisplay: false,
                                                type: 'BODY_EDITOR',
                                                required: false,
                                                show: false,
                                                copyToPayload: true,
                                            },
                                            {
                                                id: 'graphQlVariables',
                                                displayName: 'Variables',
                                                conditionalDisplay: false,
                                                type: 'BODY_EDITOR',
                                                required: false,
                                                show: false,
                                                copyToPayload: true,
                                            },
                                        ],
                                        conditionallyDisable: true,
                                        disableConditions: [
                                            {
                                                type: 'ANY_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'httpMethod',
                                                        requiredValue: 'GET',
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        id: 'queryParams',
                                        displayName: 'Query Params',
                                        array: true,
                                        isFieldInConfiguredData: false,
                                        canAddRecord: true,
                                        isObject: true,
                                        keyFieldId: 'key',
                                        valueFieldId: 'values',
                                        canDeleteRecord: true,
                                        structure: 'TABLE',
                                        fields: [
                                            {
                                                id: 'key',
                                                displayName: 'Key',
                                                conditionalDisplay: false,
                                                type: 'TEXT',
                                                required: false,
                                                isUnique: true,
                                                position: 'COLUMN',
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0'],
                                                hideHintElements: true,
                                            },
                                            {
                                                id: 'values',
                                                displayName: 'Value',
                                                valueAsArrayInPayload: false,
                                                conditionalDisplay: false,
                                                type: 'TEXT',
                                                required: false,
                                                position: 'COLUMN',
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0'],
                                                hideHintElements: true,
                                                conditionalDisable: [
                                                    {
                                                        type: 'ANY_SATISFY',
                                                        conditions: [
                                                            {
                                                                fieldId: 'key',
                                                                valueExists: false,
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        ],
                                        recordActions: [],
                                    },
                                    {
                                        id: 'placeHolderMappings',
                                        displayName: 'PlaceHolder Mappings',
                                        array: true,
                                        isObject: true,
                                        keyFieldId: 'key',
                                        active: false,
                                        isFieldInConfiguredData: false,
                                        placHolderMapping: true,
                                        structure: 'TABLE',
                                        fields: [
                                            {
                                                id: 'key',
                                                displayName: 'Key',
                                                conditionalDisplay: false,
                                                inputTypeConditonal: false,
                                                type: 'TEXT',
                                                required: false,
                                                position: 'COLUMN',
                                                isUnique: true,
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0', 'w-[100px]'],
                                                hideHintElements: true,
                                            },
                                            {
                                                id: 'autoGenerate',
                                                displayName: 'Auto Generate',
                                                required: false,
                                                array: false,
                                                conditionalDisable: [
                                                    {
                                                        type: 'ALL_MUST_SATISFY',
                                                        conditions: [
                                                            {
                                                                fieldId: 'key',
                                                                valueExists: false,
                                                            },
                                                        ],
                                                    },
                                                ],
                                                isMasterField: true,
                                                defaultValue: false,
                                                position: 'COLUMN',
                                                placeHolderMapping: true,
                                                isFieldInConfiguredData: false,
                                                type: 'CHECKBOX',
                                                hideLabel: true,
                                                tailwindClasses: [],
                                                hideHintElements: true,
                                            },
                                            {
                                                id: 'dynamicParamsKey',
                                                displayName: 'Dynamic Params Key',
                                                required: false,
                                                type: 'DYNAMIC_PARAMS_DROPDOWN',
                                                isFieldInConfiguredData: false,
                                                options: [],
                                                validations: ['checkValueExists'],
                                                errors: [],
                                                array: false,
                                                position: 'COLUMN',
                                                placeHolderMapping: true,
                                                conditionalDisable: [
                                                    {
                                                        type: 'ANY_SATISFY',
                                                        conditions: [
                                                            {
                                                                fieldId: 'key',
                                                                valueExists: false,
                                                            },
                                                            {
                                                                fieldId: 'autoGenerate',
                                                                requiredValue: false,
                                                            },
                                                        ],
                                                    },
                                                ],
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0', 'w-[100px]'],
                                                hideHintElements: true,
                                                supportOptionsConfigProperty: 'dynamicParamsKeys',
                                            },
                                            {
                                                id: 'fieldType',
                                                displayName: 'Field Type',
                                                required: false,
                                                type: 'TEXT',
                                                isFieldInConfiguredData: false,
                                                options: [],
                                                validations: ['checkValueExists'],
                                                errors: [],
                                                array: false,
                                                position: 'COLUMN',
                                                placeHolderMapping: true,
                                                disabled: true,
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0', 'w-[100px]'],
                                                hideHintElements: true,
                                            },
                                            {
                                                id: 'dateFormat',
                                                displayName: 'Date Format',
                                                required: false,
                                                type: 'TEXT',
                                                defaultValue: 'DD-MM-YYYY',
                                                errors: [],
                                                isFieldInConfiguredData: false,
                                                placeHolderMapping: true,
                                                position: 'COLUMN',
                                                conditionalDisable: [
                                                    {
                                                        type: 'ANY_SATISFY',
                                                        conditions: [
                                                            {
                                                                fieldId: 'key',
                                                                valueExists: false,
                                                            },
                                                            {
                                                                fieldId: 'autoGenerate',
                                                                requiredValue: false,
                                                            },
                                                            {
                                                                fieldId: 'fieldType',
                                                                requiredValue: 'SYSTEM',
                                                            },
                                                        ],
                                                    },
                                                ],
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0', 'w-[100px]'],
                                                hideHintElements: true,
                                            },
                                            {
                                                id: 'replacementPlaceHolderKey',
                                                displayName: 'Replacement Key',
                                                required: false,
                                                defaultValue: undefined,
                                                errors: [],
                                                isFieldInConfiguredData: false,
                                                position: 'COLUMN',
                                                placeHolderMapping: true,
                                                conditionalDisable: [
                                                    {
                                                        type: 'ANY_SATISFY',
                                                        conditions: [
                                                            {
                                                                fieldId: 'key',
                                                                valueExists: false,
                                                            },
                                                            {
                                                                fieldId: 'autoGenerate',
                                                                requiredValue: true,
                                                            },
                                                        ],
                                                    },
                                                ],
                                                type: 'TEXT',
                                                hideLabel: true,
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0', 'w-[100px]'],
                                                hideHintElements: true,
                                            },
                                            {
                                                id: 'additionalFieldRequired',
                                                displayName: 'Additional Field Required',
                                                show: true,
                                                required: false,
                                                position: 'COLUMN',
                                                type: 'CHECKBOX',
                                                hideLabel: true,
                                                placeHolderMapping: true,
                                                disabled: true,
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0'],
                                                hideHintElements: true,
                                            },
                                            {
                                                id: 'offsetValue',
                                                displayName: 'Offset Value',
                                                required: false,
                                                type: 'TEXT',
                                                isFieldInConfiguredData: false,
                                                options: [],
                                                validations: ['checkValueExists'],
                                                errors: [],
                                                array: false,
                                                position: 'COLUMN',
                                                placeHolderMapping: true,
                                                conditionalDisable: [
                                                    {
                                                        type: 'ANY_SATISFY',
                                                        conditions: [
                                                            {
                                                                fieldId: 'additionalFieldRequired',
                                                                requiredValue: false,
                                                            },
                                                            {
                                                                fieldId: 'additionalFieldRequired',
                                                                requiredValue: undefined,
                                                            },
                                                            {
                                                                fieldId: 'autoGenerate',
                                                                requiredValue: false,
                                                            },
                                                        ],
                                                    },
                                                ],
                                                appearance: 'outline',
                                                tailwindClasses: ['border-0', 'py-0', 'w-[100px]'],
                                                hideHintElements: true,
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                haveTabs: false,
                                structure: 'RECORD_FORM',
                                array: false,
                                fields: [
                                    {
                                        id: 'responseType',
                                        displayName: 'Response Type',
                                        required: false,
                                        errors: [],
                                        isFieldInConfiguredData: false,
                                        type: 'OPTIONS',
                                        defaultValue: undefined,
                                        supportOptionsConfigProperty: 'restApiResponseType',
                                        options: [],
                                    },
                                    {
                                        id: 'urlKey',
                                        displayName: 'URL Key',
                                        required: true,
                                        errors: [],
                                        isFieldInConfiguredData: false,
                                        conditionalDisplay: [
                                            {
                                                type: 'ALL_MUST_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'responseType',
                                                        requiredValue: 'URL',
                                                    },
                                                ],
                                            },
                                        ],
                                        type: 'TEXT',
                                    },
                                    {
                                        id: 'paginationEnabled',
                                        displayName: 'Pagination Enabled',
                                        required: false,
                                        array: false,
                                        defaultValue: false,
                                        isFieldInConfiguredData: false,
                                        type: 'INPUT_RADIO',
                                        options: [
                                            {
                                                id: 'yes',
                                                displayName: 'Yes',
                                                value: true,
                                            },
                                            {
                                                id: 'no',
                                                displayName: 'No',
                                                value: false,
                                            },
                                        ],
                                    },
                                    {
                                        type: 'TEXTAREA',
                                        id: 'paginationSchema',
                                        displayName: 'Pagination Schema',
                                        required: false,
                                        isFieldInConfiguredData: false,
                                        conditionalDisplay: [
                                            {
                                                type: 'ALL_MUST_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'paginationEnabled',
                                                        requiredValue: true,
                                                    },
                                                ],
                                            },
                                        ],
                                        informationType: 'JSON',
                                        informationSnippetType: 'snippet',
                                        supportedInformationProperty: 'paginationSchema',
                                        rows: 6,
                                    },
                                ],
                            },
                        ],
                        mustBePresentInPayload: true,
                    },
                    {
                        displayName: 'Target',
                        structure: 'RECORD_FORM',
                        array: false,
                        useAccordion: false,
                        haveTabs: false,
                        styles: {
                            container: ['border', 'border-gray-200', 'px-6', 'my-2', 'rounded', 'pb-3'],
                            displayName: ['flex', 'items-center', 'justify-between', 'w-full', '!mt-0', '!mb-[30px]'],
                        },
                        fields: [
                            {
                                id: 'assetResourceName',
                                displayName: 'App',
                                required: true,
                                type: 'CONNECTORS_APPS_DROPDOWN',
                                isFieldInMainDataOnly: false,
                                options: [],
                                errors: [],
                                array: false,
                            },
                            {
                                array: false,
                                displayName: 'Chain',
                                errors: [],
                                id: 'transformationChainName',
                                options: [],
                                required: true,
                                type: 'CONNECTORS_CHAIN_DROPDOWN',
                                isFieldInMainDataOnly: false,
                            },
                            {
                                array: false,
                                displayName: 'Transformation',
                                errors: [],
                                id: 'transformationName',
                                options: [],
                                required: true,
                                type: 'CONNECTORS_TRANSFORMATIONS_DROPDOWN',
                                isFieldInMainDataOnly: false,
                            },
                            {
                                array: false,
                                displayName: 'Source Name',
                                errors: [],
                                id: 'sourceName',
                                options: [],
                                required: true,
                                type: 'SOURCES_DROPDOWN',
                                isFieldInMainDataOnly: false,
                            },
                        ],
                    },
                ],
            },
        ],
        fieldsToRemoveInPayload: ['schedulerExpression', 'integrationType'],
    };

    authorizationSystem: IntegrationModal = {
        api: 'sourceSystem',
        canAddRecord: true,
        canTestConnection: false,
        canUpdateRecord: true,
        canDeleteRecord: true,
        canDownloadAuditTrail: true,
        displayName: 'Rest API',
        copyToPayload: false,
        tableFieldIds: ['name', 'url', 'createdByName', 'createdOn', 'lastUpdatedByName', 'lastUpdatedOn'],
        fields: [
            {
                id: 'sourceSystemId',
                displayName: 'Source system ID',
                required: true,
                inputTypeConditonal: false,
                type: 'TEXT',
                conditionalDisplay: false,
                validations: [
                    'mustNotContainSpaces',
                    'maxLength250',
                    'minLength3',
                    'mustContainAlphabets',
                    'mustContainAlphaAsFirstLetter',
                ],
                conditionalDisable: [
                    {
                        type: 'ANY_SATISFY',
                        conditions: [
                            {
                                fieldId: 'id',
                                valueExists: true,
                            },
                        ],
                    },
                ],
            },
            {
                id: 'sourceSystemName',
                displayName: 'Source system name',
                required: true,
                inputTypeConditonal: false,
                type: 'TEXT',
                conditionalDisplay: false,
            },
            {
                id: 'active',
                displayName: 'Active',
                required: true,
                inputTypeConditonal: false,
                type: 'SLIDER',
                conditionalDisplay: false,
                defaultValue: true,
                show: false,
                copyToPayload: true,
            },
            {
                id: 'createdBy',
                displayName: 'Created by',
                required: true,
                inputTypeConditonal: false,
                type: 'TEXT',
                conditionalDisplay: false,
                show: false,
                copyToPayload: true,
            },
            {
                id: 'createdOn',
                displayName: 'Created on',
                required: true,
                inputTypeConditonal: false,
                type: 'TEXT',
                conditionalDisplay: false,
                show: false,
                copyToPayload: true,
            },
            {
                id: 'updatedBy',
                displayName: 'Updated by',
                required: true,
                inputTypeConditonal: false,
                type: 'TEXT',
                conditionalDisplay: false,
                show: false,
                copyToPayload: true,
            },
            {
                id: 'updatedOn',
                displayName: 'Updated on',
                required: true,
                inputTypeConditonal: false,
                type: 'TEXT',
                conditionalDisplay: false,
                show: false,
                copyToPayload: true,
            },
        ],
        payloadType: 'FormData',
        payloadKey: 'payload',
        subSections: [
            {
                structure: 'HTTP',
                haveTabs: false,
                array: false,
                fields: [
                    {
                        id: 'integrationMethod',
                        displayName: 'Integration method',
                        required: true,
                        inputTypeConditonal: false,
                        type: 'OPTIONS',
                        defaultValue: 'RESTAPI',
                        uiType: 'HTTP-method',
                        options: [
                            {
                                id: 'RESTAPI',
                                displayName: 'REST API',
                                value: 'RESTAPI',
                            },
                            {
                                id: 'EMAIL',
                                displayName: 'Email',
                                value: 'EMAIL',
                            },
                        ],
                        errors: [],
                        appearance: 'outline',
                        tailwindClasses: ['rounded-r-none'],
                        hideHintElements: true,
                    },
                    {
                        id: 'restApiBaseUrl',
                        displayName: 'URL',
                        required: true,
                        inputTypeConditonal: false,
                        type: 'TEXT',
                        uiType: 'HTTP-url',
                        appearance: 'outline',
                        tailwindClasses: ['rounded-l-none', 'border-l-0'],
                        hideHintElements: true,
                        conditionalDisable: [
                            {
                                type: 'ANY_SATISFY',
                                conditions: [
                                    {
                                        fieldId: 'integrationMethod',
                                        requiredValue: 'EMAIL',
                                    },
                                ],
                            },
                        ],
                        errors: [],
                        isFieldInConfiguredData: false,
                    },
                ],
            },
            {
                structure: 'POSTMAN',
                haveTabs: true,
                tabs: [
                    {
                        id: 'authorisation',
                        displayName: 'Authorization',
                        array: false,
                        canAddRecord: false,
                        canDeleteRecord: false,
                        active: true,
                        noSubObjectForFields: true,
                        fields: [
                            {
                                id: 'authenticationType',
                                displayName: 'Type',
                                inputTypeConditonal: false,
                                required: true,
                                type: 'OPTIONS',
                                supportOptionsConfigProperty: 'supportedAuthenticationTypes',
                                options: [],
                            },
                            {
                                id: 'authorizationKey',
                                displayName: 'Authorization Key',
                                inputTypeConditonal: false,
                                required: false,
                                type: 'TEXT',
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                id: 'grantType',
                                displayName: 'Grant Types',
                                required: true,
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                ],
                                supportOptionsConfigProperty: 'supportedGrantTypes',
                                type: 'OPTIONS',
                                options: [],
                            },
                            {
                                id: 'authorizationUrl',
                                displayName: 'Authorization URL',
                                required: false,
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Authorization Code',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Implicit',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                ],
                                type: 'TEXT',
                            },
                            {
                                id: 'callbackUrl',
                                displayName: 'Callback URL',
                                required: false,
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Implicit',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Authorization Code',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                ],
                                type: 'TEXT',
                            },
                            {
                                id: 'accessTokenUrl',
                                displayName: 'Access Token URL',
                                required: false,
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Authorization Code',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Password Credentials',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Client Credentials',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                ],
                                type: 'TEXT',
                            },
                            {
                                id: 'clientId',
                                displayName: 'Client ID',
                                required: false,
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Authorization Code',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Implicit',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Password Credentials',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Client Credentials',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                ],
                                type: 'TEXT',
                            },
                            {
                                id: 'clientSecret',
                                displayName: 'Client Secret',
                                required: false,
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Authorization Code',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Client Credentials',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Password Credentials',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                ],
                                type: 'PASSWORD',
                            },
                            {
                                id: 'scope',
                                displayName: 'Scope',
                                required: false,
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Authorization Code',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Implicit',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Password Credentials',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Client Credentials',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                ],
                                type: 'TEXT',
                            },
                            {
                                id: 'refreshTokenUrl',
                                displayName: 'Refresh Token URL',
                                required: false,
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Authorization Code',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Implicit',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                ],
                                type: 'TEXT',
                            },
                            {
                                id: 'clientAuthentication',
                                displayName: 'Client Authentication',
                                required: false,
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Authorization Code',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Implicit',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Password Credentials',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Client Credentials',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                ],
                                type: 'OPTIONS',
                                supportOptionsConfigProperty: 'clientAuthentications',
                                options: [],
                            },
                            {
                                id: 'userName',
                                displayName: 'User Name',
                                required: true,
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'BASIC',
                                            },
                                        ],
                                    },
                                ],
                                type: 'PASSWORD',
                            },
                            {
                                id: 'password',
                                displayName: 'Password',
                                required: true,
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'BASIC',
                                            },
                                        ],
                                    },
                                ],
                                type: 'PASSWORD',
                            },
                            {
                                type: 'TEXTAREA',
                                id: 'customAuthenticationInfo',
                                displayName: 'Authentication Info',
                                required: true,
                                inputTypeConditonal: true,
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'CUSTOMAUTH',
                                            },
                                        ],
                                    },
                                ],
                                encodingType: 'btoa',
                                decodingType: 'atob',
                                informationType: 'JSON',
                                informationSnippetType: 'snippet',
                                supportedInformationProperty: 'customAuthSchema',
                                rows: 6,
                            },
                            {
                                id: 'oauthUserName',
                                displayName: 'User Name',
                                required: true,
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Password Credentials',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                ],
                                type: 'PASSWORD',
                            },
                            {
                                id: 'oauthPassword',
                                displayName: 'Password',
                                required: true,
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Password Credentials',
                                            },
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                ],
                                type: 'PASSWORD',
                            },
                            {
                                id: 'sslEnabled',
                                displayName: 'SSL Enabled',
                                required: false,
                                defaultValue: false,
                                type: 'SLIDER',
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                id: 'encryptionEnabled',
                                displayName: 'Encryption Enabled',
                                required: false,
                                defaultValue: false,
                                type: 'SLIDER',
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                id: 'sslCertificates',
                                fieldIdInPayloadAs: 'ssl_certificates',
                                displayName: 'SSL Certificates',
                                required: true,
                                type: 'FILE',
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                            {
                                                fieldId: 'sslEnabled',
                                                requiredValue: true,
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                id: 'encryptionKeyFile',
                                fieldIdInPayloadAs: 'encryption_key',
                                displayName: 'Encryption Key File',
                                required: true,
                                type: 'FILE',
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'authenticationType',
                                                requiredValue: 'OAUTH',
                                            },
                                            {
                                                fieldId: 'encryptionEnabled',
                                                requiredValue: true,
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                        childSubSections: [
                            {
                                id: 'additionalFields',
                                displayName: 'Additional Fields',
                                array: true,
                                isObject: true,
                                keyFieldId: 'key',
                                valueFieldId: 'values',
                                canAddRecord: true,
                                isFieldInConfiguredData: false,
                                canDeleteRecord: true,
                                structure: 'TABLE',
                                haveTabs: false,
                                fields: [
                                    {
                                        id: 'key',
                                        displayName: 'Key',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'TEXT',
                                        required: false,
                                        isUnique: true,
                                        position: 'COLUMN',
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'values',
                                        displayName: 'Value',
                                        valueAsArrayInPayload: false,
                                        conditionalDisplay: false,
                                        type: 'TEXT',
                                        required: true,
                                        validations: ['checkValueExists'],
                                        conditionalDisable: [
                                            {
                                                type: 'ANY_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'key',
                                                        valueExists: false,
                                                    },
                                                ],
                                            },
                                        ],
                                        position: 'COLUMN',
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                ],
                            },
                            {
                                id: 'additionalAuthParams',
                                displayName: 'Additional Params',
                                array: true,
                                isObject: true,
                                keyFieldId: 'key',
                                valueFieldId: 'values',
                                canAddRecord: true,
                                isFieldInConfiguredData: false,
                                canDeleteRecord: true,
                                structure: 'TABLE',
                                haveTabs: false,
                                fields: [
                                    {
                                        id: 'key',
                                        displayName: 'Key',
                                        conditionalDisplay: false,
                                        inputTypeConditonal: false,
                                        type: 'TEXT',
                                        required: false,
                                        isUnique: true,
                                        position: 'COLUMN',
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                    {
                                        id: 'values',
                                        displayName: 'Value',
                                        valueAsArrayInPayload: false,
                                        conditionalDisplay: false,
                                        type: 'TEXT',
                                        required: true,
                                        validations: ['checkValueExists'],
                                        conditionalDisable: [
                                            {
                                                type: 'ANY_SATISFY',
                                                conditions: [
                                                    {
                                                        fieldId: 'key',
                                                        valueExists: false,
                                                    },
                                                ],
                                            },
                                        ],
                                        position: 'COLUMN',
                                        appearance: 'outline',
                                        tailwindClasses: ['border-0', 'py-0'],
                                        hideHintElements: true,
                                    },
                                ],
                                conditionalDisplay: [
                                    {
                                        type: 'ALL_MUST_SATISFY',
                                        conditions: [
                                            {
                                                fieldId: 'grantType',
                                                requiredValue: 'Authorization Code',
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
        fieldsToRemoveInPayload: ['createdOn', 'updatedOn', 'schedulerExpression'],
    };
}

export const mastersScheduler: IntegrationModal = {
    api: 'inbound',
    canAddRecord: false,
    canTestConnection: true,
    useMaster: true,
    canUpdateRecord: true,
    displayName: 'Master Scheduler',
    tableFieldIds: ['configName', 'chainName', 'transformationName', 'createdByName', 'createdOn', 'lastUpdatedByName', 'lastUpdatedOn'],
    tableRecordActions: undefined,
    fields: [
        {
            array: false,
            displayName: 'Configuration Name',
            defaultValue: 'DefaultConfiguration',
            errors: [],
            id: 'configName',
            conditionalDisable: [
                {
                    type: 'ANY_SATISFY',
                    conditions: [
                        {
                            fieldId: 'locationId',
                            valueExists: true,
                        },
                    ],
                },
            ],
            options: [],
            required: true,
            type: 'TEXT',
            isFieldInMainDataOnly: true,
        },
        {
            array: false,
            displayName: 'Chain',
            errors: [],
            id: 'chainName',
            options: [],
            required: true,
            type: 'CHAIN_DROPDOWN',
            isFieldInMainDataOnly: true,
            conditionalDisable: [
                {
                    type: 'ALL_MUST_SATISFY',
                    conditions: [
                        {
                            fieldId: 'locationId',
                            valueExists: true,
                        },
                        {
                            fieldId: 'chainName',
                            valueExists: true,
                        },
                    ],
                },
            ],
        },
        {
            array: false,
            displayName: 'Transformation',
            errors: [],
            id: 'transformationName',
            options: [],
            required: true,
            type: 'TRANSFORMATIONS_DROPDOWN',
            isFieldInMainDataOnly: true,
        },
        {
            id: 'masterId',
            displayName: 'Master Data Table',
            required: true,
            type: 'MASTER_DROPDOWN',
        },
        {
            id: 'createdByName',
            displayName: 'Created By',
            required: false,
            type: 'TEXT',
            show: false,
            copyToPayload: false,
        },
        {
            id: 'createdOn',
            displayName: 'Created Date',
            required: false,
            type: 'TEXT',
            show: false,
            decodingType: 'DATE',
            copyToPayload: false,
        },
        {
            id: 'lastUpdatedByName',
            displayName: 'Modified By',
            required: false,
            type: 'TEXT',
            show: false,
            copyToPayload: false,
        },
        {
            id: 'lastUpdatedOn',
            displayName: 'Modified Date',
            required: false,
            type: 'TEXT',
            show: false,
            decodingType: 'DATE',
            copyToPayload: false,
        },
    ],
    subSections: [
        {
            displayName: 'Integration Methods by using Masters',
            id: 'configs',
            structure: 'FORM',
            array: false,
            haveTabs: false,
            fields: [
                {
                    array: false,
                    displayName: 'Integration Method',
                    errors: [],
                    id: 'integrationMethod',
                    options: [
                        {
                            displayName: 'Asset',
                            id: 'asset',
                            value: 'ASSET',
                        },
                    ],
                    required: true,
                    type: 'OPTIONS',
                },
                {
                    array: true,
                    displayName: 'Select Organization',
                    errors: [],
                    id: 'orgUnitDetail',
                    options: [],
                    required: true,
                    type: 'ORGANIZATIONS_CHECKBOX',
                    isFieldInConfiguredData: true,
                    fieldIdInPayloadAs: 'unitId',
                    payloadType: 'ORGANIZATION',
                },
            ],
        },
        {
            structure: 'POSTMAN',
            haveTabs: true,
            tabsInProperty: 'list',
            tabs: [
                {
                    id: 'attributes',
                    displayName: 'Attributes',
                    array: true,
                    canAddRecord: false,
                    active: true,
                    isFieldInConfiguredData: true,
                    canDeleteRecord: false,
                    fieldsType: 'UNIQUE-SBS',
                    propertiesToInclude: ['dataFormat', 'dataType'],
                    fields: [],
                    dynamicFields: true,
                    recordActions: [
                        {
                            id: 'dynamic',
                            displayName: 'Dynamic',
                            hideLabel: true,
                            conditionalDisplay: false,
                            inputTypeConditonal: false,
                            type: 'CHECKBOX',
                            required: false,
                            defaultValue: false,
                        },
                    ],
                    tabsInProperty: 'list',
                },
            ],
        },
        {
            displayName: 'Scheduler Details',
            id: 'configs',
            structure: 'FORM',
            array: false,
            haveTabs: false,
            fields: [
                {
                    array: false,
                    displayName: 'Active',
                    errors: [],
                    id: 'active',
                    required: true,
                    type: 'DROPDOWN',
                    isFieldInConfiguredData: true,
                },
                {
                    array: false,
                    displayName: 'Scheduler Expression',
                    errors: [],
                    id: 'schedulerExpression',
                    options: [],
                    required: true,
                    type: 'DROPDOWN',
                },
                {
                    array: false,
                    displayName: 'Last Executed Time',
                    errors: [],
                    id: 'lastExecutionField',
                    options: [],
                    required: true,
                    type: 'DROPDOWN',
                },
            ],
        },
    ],
};
